(function() {
  var STEP_REGEX = /multi-stepper-form__step--(\d+)/;
  var MAX_IMAGE_SIZE = 20 * 1024 * 1024;

  function parseJson(el) {
    if (!el || !el.textContent) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function esc(s) {
    return (s || '').replace(/</g, '&lt;').replace(/&/g, '&amp;');
  }

  function ensurePdfWorker() {
    if (typeof pdfjsLib !== 'undefined' && !pdfjsLib.GlobalWorkerOptions.workerSrc) {
      pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
    }
  }

  function isHeicFile(file) {
    if (!file || !file.type) return /\.(heic|heif)$/i.test(file.name || '');
    return file.type === 'image/heic' || file.type === 'image/heif' || /\.(heic|heif)$/i.test(file.name || '');
  }

  function isPdfFile(file) {
    if (!file) return false;
    return file.type === 'application/pdf' || /\.pdf$/i.test(file.name || '');
  }

  function sanitizeInput(value, type) {
    if (!value || typeof value !== 'string') return '';
    if (type === 'numeric') return value.replace(/[^\d.]/g, '').replace(/^(\d*\.)(.*)/, function(_, a, b) { return a + (b || '').replace(/\./g, ''); });
    if (type === 'phone') return value.replace(/[^\d\s\-\(\)\+\.]/g, '');
    return value;
  }

  function init(root) {
    if (!root) return;
    var card = root.querySelector('.multi-stepper-form__card');
    if (!card) return;
    initDeclaredValueCurrency();

    var itemConfigEl = root.querySelector('[data-item-config]');
    var serviceStep3El = root.querySelector('[data-service-step3-fields]');
    var servicesTitleEl = root.querySelector('[data-services-step-title]');
    var servicesInstructionsEl = root.querySelector('[data-services-step-instructions]');
    var step3FieldsContainer = root.querySelector('[data-step3-fields]');
    var summaryEl = root.querySelector('[data-summary]');
    var submitBtn = root.querySelector('.multi-stepper-form__btn--submit');
    var reviewImageUrls = [];

    var defaultServicesTitle = servicesTitleEl ? servicesTitleEl.textContent : '';
    var defaultServicesInstructions = servicesInstructionsEl ? servicesInstructionsEl.textContent : '';
    var selectedItemLabel = '';
    var formData = { item: null, services: [], step3_fields: {}, description: null, declared_value_currency: '', declared_value_currency_code: '' };
    var step2PlusInitialized = false;

    function initStep2Plus() {
      if (step2PlusInitialized) return;
      step2PlusInitialized = true;
      filterItemDetailsByItem(selectedItemLabel);
      initImageUploadPreviews();
    }

    function getFormCurrency() {
      var sym = root.getAttribute('data-currency-symbol');
      var code = root.getAttribute('data-currency-code');
      return { symbol: (sym && sym.trim()) || (typeof theme !== 'undefined' && theme.currencySymbol) || '$', code: (code && code.trim()) || (typeof theme !== 'undefined' && theme.currencyCode) || 'USD' };
    }

    function initDeclaredValueCurrency() {
      var cur = getFormCurrency();
      root.querySelectorAll('[data-declared-value-prefix]').forEach(function(span) { span.textContent = cur.symbol; });
    }

    function normDeclaredValue(val) {
      if (!val || typeof val !== 'string') return '';
      return val.replace(/,/g, '').replace(/[^\d.]/g, '').replace(/^\./, '0.').replace(/(\..*)\./g, '$1').trim();
    }

    function norm(s) { return (s || '').trim().toLowerCase(); }

    function setVisible(el, show) {
      var d = show ? '' : 'none';
      if (el) el.style.display = d;
      var wrap = el && el.closest && el.closest('.shopify-block');
      if (!wrap) return;
      if (wrap === el.parentElement || (wrap.classList && (wrap.classList.contains('searvice_main') || wrap.classList.contains('searvice-group_main'))))
        wrap.style.display = d;
    }

    function getItemConfig() { return parseJson(itemConfigEl); }
    function getServiceStep3Config() { return parseJson(serviceStep3El); }

    function applyServicesStepContent(itemLabel) {
      var config = getItemConfig();
      var key = norm(itemLabel);
      for (var i = 0; i < config.length; i++) {
        if (norm(config[i].label) === key) {
          if (servicesTitleEl && config[i].services_step_title) servicesTitleEl.textContent = config[i].services_step_title;
          if (servicesInstructionsEl && config[i].services_step_instructions) servicesInstructionsEl.textContent = config[i].services_step_instructions;
          return;
        }
      }
      if (servicesTitleEl) servicesTitleEl.textContent = defaultServicesTitle;
      if (servicesInstructionsEl) servicesInstructionsEl.textContent = defaultServicesInstructions;
    }

    function showStep(stepNum) {
      var idx = (parseInt(stepNum, 10) || 1) - 1;
      if (idx < 0) idx = 0;
      var slides = [];
      for (var i = 0; i < card.children.length; i++) {
        var slide = card.children[i];
        if (slide.classList && slide.classList.contains('multi-stepper-form__empty-state')) { slide.hidden = true; continue; }
        var stepEl = slide.querySelector && slide.querySelector('.multi-stepper-form__step');
        if (stepEl) {
          slides.push({ slide: slide, step: stepEl });
          continue;
        }
        var confirmationEl = slide.querySelector && slide.querySelector('[data-confirmation-block], .multi-stepper-form__confirmation');
        if (confirmationEl) {
          slides.push({ slide: slide, step: null });
          continue;
        }
        slide.hidden = true;
      }
      if (idx >= slides.length) idx = slides.length - 1;
      for (var j = 0; j < slides.length; j++) {
        var on = j === idx;
        if (slides[j].step) {
          slides[j].step.hidden = !on;
          slides[j].step.classList.toggle('is-active', on);
        }
        slides[j].slide.hidden = !on;
        if (on) {
          var conf = slides[j].slide.querySelector && slides[j].slide.querySelector('[data-confirmation-block], .multi-stepper-form__confirmation');
          if (conf) conf.removeAttribute('hidden');
        }
      }
      if (idx < slides.length && slides[idx] && slides[idx].step) {
        var confirmationBlock = root.querySelector('[data-confirmation-block]');
        if (confirmationBlock) confirmationBlock.classList.remove('is-submitted');
      }
      var currentStepNum = parseInt(stepNum, 10) || 1;
      setTimeout(function() {
        if (idx < slides.length && slides[idx] && slides[idx].step) {
          updateNextButtonForStep(currentStepNum);
          updateImageUploadStepButton();
          if (slides[idx].step.querySelector && slides[idx].step.querySelector('[data-review]')) renderReview();
          var targetEl = slides[idx].slide || slides[idx].step;
          if (targetEl && targetEl.scrollIntoView) targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else if (idx < slides.length && slides[idx] && !slides[idx].step) {
          updateConfirmationSubmitButton();
          var targetEl = slides[idx].slide;
          if (targetEl && targetEl.scrollIntoView) targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        updateConfirmationEmail();
      }, 0);
    }

    function updateConfirmationSubmitButton() {
      var confirmationBlock = root.querySelector('[data-confirmation-block]');
      if (!confirmationBlock || confirmationBlock.classList.contains('is-submitted')) return;
      var confirmVerify = confirmationBlock.querySelector('[data-confirmation-email-verify]');
      var contactEmailInp = root.querySelector('[name="step3[contact_email]"]');
      var contactEmail = contactEmailInp ? (contactEmailInp.value || '').trim() : '';
      var confirmEmail = confirmVerify ? (confirmVerify.value || '').trim() : '';
      var filled = confirmVerify && confirmVerify.checkValidity && confirmVerify.checkValidity() && confirmEmail.toLowerCase() === contactEmail.toLowerCase();
      confirmationBlock.querySelectorAll('.multi-stepper-form__btn--submit, [data-confirmation-submit]').forEach(function(btn) {
        btn.disabled = !filled;
      });
    }

    function updateConfirmationEmail() {
      var contactEmailInp = root.querySelector('[name="step3[contact_email]"]');
      var email = contactEmailInp && (contactEmailInp.value || '').trim();
      var value = email || '';
      var visibleStep = root.querySelector('.multi-stepper-form__step:not([hidden])');
      if (visibleStep) {
        var stepEmailEl = visibleStep.querySelector('[data-confirmation-email]');
        if (stepEmailEl) {
          if (stepEmailEl.tagName === 'INPUT') stepEmailEl.value = value;
          else stepEmailEl.textContent = value || '—';
        }
      }
      var confirmationEmailEl = root.querySelector('[data-confirmation-block] [data-confirmation-email]');
      if (confirmationEmailEl) {
        if (confirmationEmailEl.tagName === 'INPUT') confirmationEmailEl.value = value;
        else confirmationEmailEl.textContent = value || '—';
      }
      var confirmVerifyEl = root.querySelector('[data-confirmation-block] [data-confirmation-email-verify]');
      if (confirmVerifyEl) confirmVerifyEl.value = '';
      var confirmationBlock = root.querySelector('[data-confirmation-block]');
      if (confirmationBlock && !confirmationBlock.hidden && !confirmationBlock.classList.contains('is-submitted')) {
        updateConfirmationSubmitButton();
      }
    }

    function filterServicesByItem(itemLabel) {
      var key = norm(itemLabel);
      var scope = root.querySelector('[data-service-list]') || root;
      var els = scope.querySelectorAll('[data-item-label]');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var show = norm(el.getAttribute('data-item-label')) === key;
        setVisible(el, show);
      }
      root.querySelectorAll('.multi-stepper-form__service-check').forEach(function(cb) {
        var cardEl = cb.closest('.multi-stepper-form__service-card');
        if (cardEl && norm(cardEl.getAttribute('data-item-label')) !== key) cb.checked = false;
      });
    }

    function filterItemDetailsByItem(itemLabel) {
      var key = norm(itemLabel);
      var panels = root.querySelectorAll('.multi-stepper-form__item-details[data-item-details-panel]');
      for (var i = 0; i < panels.length; i++) {
        var panel = panels[i];
        var label = norm((panel.getAttribute('data-item-label') || '').trim());
        var show = key !== '' && label === key;
        panel.hidden = !show;
        var wrap = panel.closest && panel.closest('.shopify-block');
        if (wrap) wrap.style.display = show ? '' : 'none';
        var inputs = panel.querySelectorAll('input, textarea, select');
        for (var j = 0; j < inputs.length; j++) {
          var inp = inputs[j];
          if (inp.hasAttribute('data-required') || inp.hasAttribute('required')) {
            if (show) inp.setAttribute('required', 'required');
            else inp.removeAttribute('required');
          }
        }
        panel.querySelectorAll('[data-service-has-text]').forEach(function(cb) {
          var key = cb.getAttribute('data-service-key');
          var wrap = key ? panel.querySelector('[data-service-text-wrap][data-service-key="' + key + '"]') : null;
          var textarea = key ? panel.querySelector('[data-service-textarea][data-service-key="' + key + '"]') : null;
          if (wrap) wrap.hidden = !cb.checked;
          if (textarea) {
            if (cb.checked) textarea.setAttribute('required', 'required');
            else textarea.removeAttribute('required');
          }
        });
        if (panel.hasAttribute('data-jewelry-services-block') && !show) {
          var typeSelect = panel.querySelector('[data-jewelry-type-select]');
          var otherWrap = panel.querySelector('[data-jewelry-other-wrap]');
          var otherInp = panel.querySelector('[data-jewelry-type-other]');
          var servicesGroup = panel.querySelector('[data-jewelry-services-group]');
          var checkboxes = panel.querySelector('[data-jewelry-services-checkboxes]');
          if (typeSelect) typeSelect.value = '';
          if (otherWrap) otherWrap.style.display = 'none';
          if (otherInp) { otherInp.value = ''; otherInp.removeAttribute('required'); }
          if (servicesGroup) servicesGroup.style.display = 'none';
          if (checkboxes) checkboxes.innerHTML = '';
        }
      }
      root.querySelectorAll('[data-jewelry-services-block]:not([hidden])').forEach(function(block) { initJewelryServicesBlock(block); });
    }

    function initJewelryServicesBlock(block) {
      var configEl = block.querySelector('[data-jewelry-services-config]');
      var promptsEl = block.querySelector('[data-jewelry-services-prompts]');
      var config = {};
      var promptsSet = {};
      if (configEl && configEl.textContent) {
        try {
          var raw = JSON.parse(configEl.textContent);
          if (Array.isArray(raw)) {
            for (var r = 0; r < raw.length; r++) {
              var line = (raw[r] || '').trim();
              var colonIdx = line.indexOf(':');
              if (colonIdx >= 0) {
                var key = line.substring(0, colonIdx).trim().toLowerCase();
                var servicesStr = line.substring(colonIdx + 1).trim();
                var services = servicesStr.split(',').map(function(s) { return s.trim(); }).filter(Boolean);
                if (key) config[key] = services;
              }
            }
          }
        } catch (e) {}
      }
      if (Object.keys(config).length === 0) {
        config = { ring: ['Polish','Stone Replacement','Sizing','Stone Tightening','Prong Repair','Sizing Balls','Engraving','Other'], bracelet: ['Polish','Stone Replacement','Clasp Repair','Stone Tightening','Prong Repair','Link Repair','Engraving','Add Safety Chain','Other'], necklace: ['Polish','Stone Replacement','Clasp Repair','Stone Tightening','Prong Repair','Link Repair','Engraving','Chain Extender','Other'], earrings: ['Polish','Stone Replacement','Post Replacement','Stone Tightening','Prong Repair','Link Repair','Engraving','Earring Back Replacement','Other'], other: ['Polish','Prong Repair','Stone Replacement','Sizing Balls','Link Repair','Clasp Repair','Post Replacement','Sizing','Engraving','Stone Tightening','Add Safety Chain','Chain Extender','Earring Back Replacement','Other'] };
      }
      if (promptsEl && promptsEl.textContent) {
        try {
          var promptsArr = JSON.parse(promptsEl.textContent);
          if (Array.isArray(promptsArr)) {
            for (var p = 0; p < promptsArr.length; p++) {
              var svcName = (promptsArr[p] || '').trim();
              if (svcName) promptsSet[svcName] = true;
            }
          }
        } catch (e) {}
      }
      var typeSelect = block.querySelector('[data-jewelry-type-select]');
      var otherWrap = block.querySelector('[data-jewelry-other-wrap]');
      var otherInp = block.querySelector('[data-jewelry-type-other]');
      var servicesGroup = block.querySelector('[data-jewelry-services-group]');
      var checkboxes = block.querySelector('[data-jewelry-services-checkboxes]');
      if (!typeSelect || !checkboxes) return;
      function onTypeChange() {
        var val = (typeSelect.value || '').trim();
        var key = val.toLowerCase();
        if (otherWrap) {
          var isOther = (key === 'other' || (key && /\bother\b/i.test(key)));
          otherWrap.style.display = isOther ? '' : 'none';
          if (otherInp) {
            if (isOther) otherInp.setAttribute('required', 'required');
            else { otherInp.removeAttribute('required'); otherInp.value = ''; }
          }
        }
        var configKey = config[key] ? key : (key && /\bother\b/i.test(key) ? 'other' : key);
        var prevKey = (block.getAttribute('data-jewelry-last-key') || '').toLowerCase();
        var typeChanged = configKey !== prevKey;
        var savedTextValues = {};
        if (!typeChanged) {
          block.querySelectorAll('[data-service-text-wrap]').forEach(function(wrap) {
            var sk = wrap.getAttribute('data-service-key');
            var ta = wrap.querySelector('[data-service-textarea]');
            if (sk && ta && ta.value) savedTextValues[sk] = ta.value;
          });
        }
        block.querySelectorAll('[data-service-text-wrap]').forEach(function(wrap) {
          wrap.hidden = true;
          var ta = wrap.querySelector('[data-service-textarea]');
          if (ta) {
            ta.removeAttribute('required');
            if (typeChanged) ta.value = '';
          }
        });
        if (config[configKey] && config[configKey].length) {
          var savedChecked = [];
          if (prevKey === configKey) {
            checkboxes.querySelectorAll('input[type="checkbox"]').forEach(function(c) { if (c.checked && c.value) savedChecked.push(c.value); });
          }
          block.setAttribute('data-jewelry-last-key', configKey);
          checkboxes.innerHTML = '';
          for (var i = 0; i < config[configKey].length; i++) {
            var svc = config[configKey][i];
            var handle = svc.toLowerCase().replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '');
            var id = 'jewelry-svc-' + (block.id || '') + '-' + handle;
            var cb = document.createElement('label');
            cb.className = 'multi-stepper-form__checkbox-label multi-stepper-form__jewelry-service-checkbox';
            var inp = document.createElement('input');
            inp.type = 'checkbox';
            inp.name = 'step3[jewelry_services_' + handle + ']';
            inp.value = svc;
            inp.id = id;
            if (promptsSet[svc]) {
              inp.setAttribute('data-service-has-text', '');
              inp.setAttribute('data-service-key', handle);
            }
            if (savedChecked.indexOf(svc) >= 0) inp.checked = true;
            cb.appendChild(inp);
            cb.appendChild(document.createTextNode(' ' + svc));
            checkboxes.appendChild(cb);
          }
          checkboxes.querySelectorAll('input[data-service-has-text]').forEach(function(cb) {
            if (cb.checked) {
              var sk = cb.getAttribute('data-service-key');
              var wrap = block.querySelector('[data-service-text-wrap][data-service-key="' + sk + '"]');
              if (wrap) wrap.hidden = false;
              var textarea = block.querySelector('[data-service-textarea][data-service-key="' + sk + '"]');
              if (textarea) {
                textarea.setAttribute('required', 'required');
                if (savedTextValues[sk]) textarea.value = savedTextValues[sk];
              }
            }
          });
          servicesGroup.style.display = '';
          servicesGroup.setAttribute('data-jewelry-services-visible', 'true');
        } else {
          block.removeAttribute('data-jewelry-last-key');
          checkboxes.innerHTML = '';
          servicesGroup.style.display = 'none';
          servicesGroup.removeAttribute('data-jewelry-services-visible');
        }
        setTimeout(function() {
          var stepEl = block.closest && block.closest('[class*="multi-stepper-form__step--"]');
          var stepNum = stepEl && stepEl.className ? ((stepEl.className.match(STEP_REGEX) || [])[1]) : null;
          if (stepNum) updateNextButtonForStep(parseInt(stepNum, 10));
          renderReview();
        }, 0);
      }
      typeSelect.removeEventListener('change', typeSelect._jewelryOnChange);
      typeSelect._jewelryOnChange = onTypeChange;
      typeSelect.addEventListener('change', onTypeChange);
      if (typeSelect.value) onTypeChange();
    }

    function resetForm() {
      root.querySelectorAll('.multi-stepper-form__service-check').forEach(function(cb) {
        cb.checked = false;
      });
      root.querySelectorAll('.multi-stepper-form__item-details[data-item-details-panel]').forEach(function(panel) {
        panel.querySelectorAll('input, textarea, select').forEach(function(inp) {
          if (inp.type === 'checkbox' || inp.type === 'radio') inp.checked = false;
          else inp.value = '';
        });
        if (panel.hasAttribute('data-jewelry-services-block')) {
          var typeSelect = panel.querySelector('[data-jewelry-type-select]');
          var otherWrap = panel.querySelector('[data-jewelry-other-wrap]');
          var otherInp = panel.querySelector('[data-jewelry-type-other]');
          var servicesGroup = panel.querySelector('[data-jewelry-services-group]');
          var checkboxes = panel.querySelector('[data-jewelry-services-checkboxes]');
          if (typeSelect) typeSelect.value = '';
          if (otherWrap) otherWrap.style.display = 'none';
          if (otherInp) otherInp.removeAttribute('required');
          if (servicesGroup) { servicesGroup.style.display = 'none'; servicesGroup.removeAttribute('data-jewelry-services-visible'); }
          if (checkboxes) checkboxes.innerHTML = '';
          panel.removeAttribute('data-jewelry-last-key');
          panel.querySelectorAll('[data-service-text-wrap]').forEach(function(wrap) {
            wrap.hidden = true;
            var ta = wrap.querySelector('[data-service-textarea]');
            if (ta) { ta.removeAttribute('required'); ta.value = ''; }
          });
        }
        root.querySelectorAll('select[data-select-has-other]').forEach(function(sel) {
          toggleSelectOtherWrap(sel);
        });
      });
      root.querySelectorAll('.multi-stepper-form__step3-field').forEach(function(field) {
        field.querySelectorAll('input, textarea, select').forEach(function(inp) {
          if (inp.type === 'checkbox' || inp.type === 'radio') inp.checked = false;
          else inp.value = '';
        });
      });
      var contactBlock = root.querySelector('[data-contact-info]');
      if (contactBlock) {
        contactBlock.querySelectorAll('input, textarea, select').forEach(function(inp) {
          if (inp.type === 'checkbox' || inp.type === 'radio') inp.checked = false;
          else inp.value = '';
        });
      }
      var descEl = root.querySelector('textarea[name="description"]');
      if (descEl) descEl.value = '';
      root.querySelectorAll('[data-image-uploads] [data-upload-input]').forEach(function(inp) {
        inp.value = '';
        inp._compressedBlob = null;
        inp._compressedFileName = null;
        inp._isPdf = false;
        inp._previewJpegBlob = null;
        var item = inp.closest('[data-upload-slot]');
        var dropZone = item && item.querySelector('[data-drop-zone]');
        if (dropZone) {
          var previewImg = dropZone.querySelector('[data-upload-preview-img]');
          var pdfPreviewEl = dropZone.querySelector('[data-pdf-preview]');
          clearPreview(previewImg, dropZone, pdfPreviewEl);
        }
      });
      root.dispatchEvent(new CustomEvent('multi-stepper-form-reset-uploads'));
      var refContainer = getStepElement(3) && getStepElement(3).querySelector('[data-reference-uploads-container]');
      if (refContainer) {
        refContainer.innerHTML = '';
        refContainer.style.display = 'none';
      }
      setTimeout(function() {
        updateNextButtonForStep(2);
        updateNextButtonForStep(3);
        updateNextButtonForStep(4);
        updateImageUploadStepButton();
        renderSummary();
        renderReview();
      }, 0);
    }

    function getServicesWithUploadReference() {
      var key = norm(selectedItemLabel);
      var list = [];
      root.querySelectorAll('.multi-stepper-form__service-check').forEach(function(cb) {
        if (!cb.checked) return;
        var cardEl = cb.closest('.multi-stepper-form__service-card');
        if (!cardEl || cardEl.style.display === 'none') return;
        if (norm((cardEl.getAttribute('data-item-label') || '')) !== key) return;
        if (cb.getAttribute('data-upload-reference') !== 'true') return;
        var title = (cb.getAttribute('data-service-title') || cb.value || '').trim();
        var id = cb.getAttribute('data-service-id') || '';
        if (title) list.push({ serviceTitle: title, serviceId: id });
      });
      return list;
    }

    function updateReferenceUploadSections() {
      var step3 = getStepElement(3);
      if (!step3) return;
      var container = step3.querySelector('[data-reference-uploads-container]');
      if (!container) return;
      var services = getServicesWithUploadReference();
      var existingIds = {};
      container.querySelectorAll('[data-reference-service-id]').forEach(function(el) {
        existingIds[el.getAttribute('data-reference-service-id')] = el;
      });
      var toAdd = [];
      for (var i = 0; i < services.length; i++) {
        var sid = services[i].serviceId || services[i].serviceTitle;
        if (!existingIds[sid]) toAdd.push(services[i]);
      }
      for (var j = 0; j < services.length; j++) {
        var s = services[j];
        var sid = s.serviceId || s.serviceTitle;
        if (existingIds[sid]) delete existingIds[sid];
      }
      for (var k in existingIds) existingIds[k].remove();
      for (var n = 0; n < toAdd.length; n++) {
        var sect = document.createElement('div');
        sect.className = 'multi-stepper-form__reference-upload-section';
        sect.setAttribute('data-reference-service-id', toAdd[n].serviceId || toAdd[n].serviceTitle);
        sect.setAttribute('data-reference-service-title', toAdd[n].serviceTitle);
        sect.innerHTML = 
          '<div class="multi-stepper-form__reference-upload-item" data-reference-upload-slot>' +
          '<span class="multi-stepper-form__reference-upload-label">' + (toAdd[n].serviceTitle || 'Reference') + ' Reference Image</span>' +
          '<input type="file" class="multi-stepper-form__reference-upload-input" accept="image/*,.heic,.heif,application/pdf,.pdf" data-reference-upload-input data-reference-service-id="' + (toAdd[n].serviceId || '') + '" data-reference-service-title="' + (toAdd[n].serviceTitle || '').replace(/"/g, '&quot;') + '" aria-label="' + (toAdd[n].serviceTitle || 'Reference') + ' reference image">' +
          '<div class="multi-stepper-form__reference-drop-zone" data-reference-drop-zone tabindex="0" role="button">' +
          '<span class="multi-stepper-form__reference-drop-placeholder" data-reference-drop-placeholder>Choose file</span>' +
          '<span class="multi-stepper-form__reference-drop-filename" data-reference-filename>No file chosen</span>' +
          '<img src="" alt="" class="multi-stepper-form__reference-preview-img" data-reference-preview-img style="display:none">' +
          '<button type="button" class="multi-stepper-form__reference-remove" data-reference-remove aria-label="Remove" style="display:none">&times;</button>' +
          '</div>' +
          '<div class="multi-stepper-form__reference-upload-error" data-reference-upload-error role="alert"></div>' +
          '</div>';
        container.appendChild(sect);
        setupReferenceUploadSection(sect);
      }
      container.style.display = services.length > 0 ? '' : 'none';
    }

    function setupReferenceUploadSection(section) {
      var inp = section.querySelector('[data-reference-upload-input]');
      var dropZone = section.querySelector('[data-reference-drop-zone]');
      var placeholder = section.querySelector('[data-reference-drop-placeholder]');
      var filenameEl = section.querySelector('[data-reference-filename]');
      var previewImg = section.querySelector('[data-reference-preview-img]');
      var removeBtn = section.querySelector('[data-reference-remove]');
      var errEl = section.querySelector('[data-reference-upload-error]');
      function showRefError(msg) {
        if (errEl) { errEl.textContent = msg || ''; errEl.style.display = msg ? '' : 'none'; }
      }
      function setRefPreview(blob) {
        if (previewImg && previewImg._prevUrl) { URL.revokeObjectURL(previewImg._prevUrl); previewImg._prevUrl = null; }
        if (!blob) {
          if (previewImg) { previewImg.style.display = 'none'; previewImg.removeAttribute('src'); }
          if (placeholder) placeholder.style.display = '';
          if (filenameEl) { filenameEl.textContent = 'No file chosen'; filenameEl.style.display = ''; }
          if (dropZone) dropZone.classList.remove('has-preview');
          if (removeBtn) removeBtn.style.display = 'none';
          return;
        }
        var url = URL.createObjectURL(blob);
        if (previewImg) { previewImg._prevUrl = url; previewImg.src = url; previewImg.style.display = ''; }
        if (placeholder) placeholder.style.display = 'none';
        if (filenameEl) filenameEl.style.display = 'none';
        if (dropZone) dropZone.classList.add('has-preview');
        if (removeBtn) removeBtn.style.display = 'flex';
      }
      function handleRefFile(file) {
        if (!file) {
          inp.value = '';
          inp._compressedBlob = null;
          inp._refFileName = null;
          inp._isPdf = false;
          inp._previewJpegBlob = null;
          setRefPreview(null);
          showRefError('');
          return;
        }
        var isHeic = isHeicFile(file);
        var isPdf = isPdfFile(file);
        var isImage = file.type && file.type.indexOf('image/') === 0;
        if (!isImage && !isHeic && !isPdf) {
          showRefError('Please select an image, HEIC, or PDF file.');
          inp.value = '';
          return;
        }
        if (file.size > MAX_IMAGE_SIZE) {
          showRefError('File must be under 20 MB.');
          inp.value = '';
          return;
        }
        showRefError('');
        dropZone.classList.add('is-loading');
        function finish(blob, fileName, isPdfFile) {
          dropZone.classList.remove('is-loading');
          inp._compressedBlob = blob;
          inp._refFileName = fileName || 'image.jpg';
          inp._isPdf = !!isPdfFile;
          inp._previewJpegBlob = isPdfFile ? null : blob;
          setRefPreview(blob);
          setTimeout(function() { renderReview(); }, 0);
        }
        if (isHeic) {
          if (typeof heic2any !== 'function') {
            showRefError('HEIC conversion not available. Please use a JPEG or PNG image.');
            dropZone.classList.remove('is-loading');
            inp.value = '';
            return;
          }
          heic2any({ blob: file, toType: 'image/jpeg', quality: 0.85 }).then(function(converted) {
            var blob = Array.isArray(converted) ? converted[0] : converted;
            if (!blob) { showRefError('Could not process HEIC image.'); dropZone.classList.remove('is-loading'); return; }
            if (blob.size <= MAX_IMAGE_SIZE) return finish(blob, (file.name || '').replace(/\.[^.]+$/, '') + '.jpg', false);
            compressImageBlob(blob, MAX_IMAGE_SIZE, 1920, 0.85, function(err, compressed) {
              if (err) { showRefError('Could not process image.'); dropZone.classList.remove('is-loading'); return; }
              finish(compressed || blob, (file.name || '').replace(/\.[^.]+$/, '') + '.jpg', false);
            });
          }).catch(function() {
            showRefError('Could not process HEIC image.');
            dropZone.classList.remove('is-loading');
            inp.value = '';
          });
          return;
        }
        if (isPdf) {
          inp._compressedBlob = file;
          inp._refFileName = file.name || 'document.pdf';
          inp._isPdf = true;
          pdfFirstPageToJpegBlob(file, 1600, 0.95, function(err, jpegBlob) {
            if (!err && jpegBlob) {
              if (jpegBlob.size > MAX_IMAGE_SIZE) {
                compressImageBlob(jpegBlob, MAX_IMAGE_SIZE, 1920, 0.9, function(compressErr, compressed) {
                  inp._previewJpegBlob = compressed || jpegBlob;
                  setRefPreview(inp._previewJpegBlob);
                  dropZone.classList.remove('is-loading');
                  setTimeout(function() { renderReview(); }, 0);
                });
              } else {
                inp._previewJpegBlob = jpegBlob;
                setRefPreview(jpegBlob);
                dropZone.classList.remove('is-loading');
                setTimeout(function() { renderReview(); }, 0);
              }
            } else {
              setRefPreview(null);
              dropZone.classList.remove('is-loading');
              setTimeout(function() { renderReview(); }, 0);
            }
          });
          return;
        }
        compressImageBlob(file, MAX_IMAGE_SIZE, 1920, 0.85, function(err, compressed) {
          if (err) { showRefError('Could not process image.'); dropZone.classList.remove('is-loading'); return; }
          var blob = compressed || file;
          finish(blob, (file.name || '').replace(/\.[^.]+$/, '') + '.jpg', false);
        });
      }
      if (removeBtn) {
        removeBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          handleRefFile(null);
        });
      }
      dropZone.addEventListener('click', function(e) {
        if (e.target === removeBtn) return;
        e.preventDefault();
        inp.click();
      });
      inp.addEventListener('change', function() {
        var file = inp.files && inp.files[0];
        handleRefFile(file);
      });
      dropZone.addEventListener('dragover', function(e) { e.preventDefault(); e.stopPropagation(); dropZone.classList.add('is-dragover'); });
      dropZone.addEventListener('dragleave', function(e) { e.preventDefault(); dropZone.classList.remove('is-dragover'); });
      dropZone.addEventListener('drop', function(e) {
        e.preventDefault();
        e.stopPropagation();
        dropZone.classList.remove('is-dragover');
        var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (file) handleRefFile(file);
      });
    }

    function getReferenceUploadImages() {
      var list = [];
      root.querySelectorAll('[data-reference-upload-input]').forEach(function(inp) {
        var blob = inp._compressedBlob || (inp.files && inp.files[0]);
        if (!blob) return;
        var serviceTitle = inp.getAttribute('data-reference-service-title') || 'Reference';
        var serviceId = inp.getAttribute('data-reference-service-id') || '';
        var fileName = inp._refFileName || (blob.name || 'image.jpg');
        var isPdf = !!inp._isPdf || (blob.type && blob.type.indexOf('pdf') >= 0) || (fileName && fileName.toLowerCase().indexOf('.pdf') >= 0);
        var useBlob = (isPdf && inp._previewJpegBlob) ? inp._previewJpegBlob : blob;
        var useFileName = (isPdf && inp._previewJpegBlob) ? (fileName || 'document.pdf').replace(/\.pdf$/i, '.jpg') : fileName;
        list.push({ serviceTitle: serviceTitle, serviceId: serviceId, file: useBlob, fileName: useFileName, isPdf: false });
      });
      return list;
    }

    function updateSelectedItemClass() {
      var key = selectedItemLabel ? norm(selectedItemLabel).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') : '';
      var cls = key ? 'item-' + key + '-selected' : '';
      function removeAndAdd(el) {
        var toRemove = [];
        for (var i = 0; i < el.classList.length; i++) {
          var cn = el.classList[i];
          if (cn && cn.indexOf('item-') === 0 && cn.indexOf('-selected') === cn.length - 9) toRemove.push(cn);
        }
        toRemove.forEach(function(c) { el.classList.remove(c); });
        if (cls) el.classList.add(cls);
      }
      removeAndAdd(root);
      root.querySelectorAll('.multi-stepper-form__step').forEach(removeAndAdd);
    }

    function onCardClick(e) {
      var btn = e.target.closest && e.target.closest('.multi-stepper-form__item-card');
      if (!btn) return;
      var newLabel = (btn.getAttribute('data-item-label') || '').trim();
      var previousLabel = selectedItemLabel;
      selectedItemLabel = newLabel;
      root.querySelectorAll('.multi-stepper-form__item-card').forEach(function(c) {
        c.classList.toggle('is-selected', c.getAttribute('data-item-label') === selectedItemLabel);
      });
      updateSelectedItemClass();
      updateNextButtonForStep(1);
      if (previousLabel !== '' && newLabel !== previousLabel) {
        resetForm();
      }
    }

    function onServiceListClick(e) {
      var toggle = e.target.closest && e.target.closest('[data-group-toggle]');
      if (!toggle) return;
      var group = toggle.closest('.multi-stepper-form__service-group');
      var body = group && group.querySelector('.multi-stepper-form__service-group-body');
      if (body) {
        var exp = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', !exp);
        body.style.display = exp ? 'none' : '';
      }
    }

    function parseLabels(str) {
      if (!str || typeof str !== 'string') return [];
      return str.split(',').map(function(s) { return s.trim(); }).filter(Boolean);
    }

    function showStep3Fields(selectedTitles) {
      if (!step3FieldsContainer) return;
      var config = getServiceStep3Config();
      var labelsToShow = {};
      for (var i = 0; i < selectedTitles.length; i++) {
        for (var j = 0; j < config.length; j++) {
          if (config[j].title === selectedTitles[i]) {
            parseLabels(config[j].field_labels || '').forEach(function(l) { labelsToShow[l] = true; });
            break;
          }
        }
      }
      var fields = step3FieldsContainer.querySelectorAll('.multi-stepper-form__step3-field');
      for (var k = 0; k < fields.length; k++) {
        var field = fields[k];
        var show = !!labelsToShow[(field.getAttribute('data-field-label') || '').trim()];
        field.style.display = show ? '' : 'none';
        field.querySelectorAll('input, textarea, select').forEach(function(input) {
          if (!show) input.removeAttribute('required');
          else if (input.hasAttribute('data-required')) input.setAttribute('required', 'required');
        });
      }
    }

    function getSelectedServices() {
      var list = [];
      root.querySelectorAll('.multi-stepper-form__service-check').forEach(function(cb) {
        var cardEl = cb.closest('.multi-stepper-form__service-card');
        if (cardEl && cardEl.style.display !== 'none' && cb.checked) {
          var descEl = cardEl.querySelector('.multi-stepper-form__service-desc');
          list.push({
            id: cb.getAttribute('data-service-id'),
            title: cb.value,
            description: descEl ? (descEl.innerText || descEl.textContent || '').trim() : ''
          });
        }
      });
      return list;
    }

    function renderSummary() {
      var services = getSelectedServices();
      formData.item = selectedItemLabel;
      formData.services = services;
      if (!summaryEl) return;
      var html = '<div class="multi-stepper-form__selected-heading">Item</div><p class="multi-stepper-form__selected-item">' + esc(selectedItemLabel) + '</p>';
      html += '<div class="multi-stepper-form__selected-heading">Selected services</div><ul class="multi-stepper-form__selected-ul">';
      if (services.length === 0) html += '<li class="multi-stepper-form__selected-empty">None</li>';
      else for (var i = 0; i < services.length; i++) html += '<li>' + esc(services[i].title) + '</li>';
      html += '</ul>';
      summaryEl.innerHTML = html;
      showStep3Fields(services.map(function(s) { return s.title; }));
      renderReview();
    }

    function getStep3ValuesFromDOM() {
      var out = {
        item: selectedItemLabel,
        tellMore: '',
        jewelryAdditionalInfo: '',
        declaredValue: '',
        brand: '',
        model: '',
        metal: '',
        centerStone: '',
        centerCarat: '',
        sideStones: '',
        extraFields: [],
        services: getSelectedServices()
      };
      var allPanels = root.querySelectorAll('.multi-stepper-form__item-details[data-item-details-panel]');
      var key = norm(selectedItemLabel || '');
      var panels = [];
      for (var pidx = 0; pidx < allPanels.length; pidx++) {
        var p = allPanels[pidx];
        var plabel = norm((p.getAttribute('data-item-label') || '').trim());
        if (key !== '' && plabel === key) panels.push(p);
      }
      if (panels.length === 0) {
        for (var pidx2 = 0; pidx2 < allPanels.length; pidx2++) {
          if (!allPanels[pidx2].hasAttribute('hidden')) panels.push(allPanels[pidx2]);
        }
      }
      if (panels.length) {
        var getVal = function(name) {
          for (var pi = 0; pi < panels.length; pi++) {
            var inp = panels[pi].querySelector('[name="' + name + '"]');
            if (inp) return inp.type === 'checkbox' ? (inp.checked ? inp.value : '') : (inp.value || '').trim();
          }
          return '';
        };
        out.tellMore = getVal('step3[watch_tell_more]') || getVal('step3[jewellery_tell_more]') || getVal('step3[jewelry_services_additional]');
        out.jewelryAdditionalInfo = getVal('step3[jewelry_services_additional]');
        var rawDecl = getVal('step3[watch_declared_value]') || getVal('step3[jewellery_declared_value]');
        out.declaredValue = normDeclaredValue(rawDecl) || rawDecl.trim();
        var cur = getFormCurrency();
        out.declaredValueCurrency = cur.symbol;
        out.declaredValueCurrencyCode = cur.code;
        var watchBrand = getVal('step3[watch_brand]');
        var watchBrandOther = getVal('step3[watch_brand_other]');
        var jewelleryMetal = getVal('step3[jewellery_metal]');
        var jewelleryMetalOther = getVal('step3[jewellery_metal_other]');
        var jewelleryCenterStone = getVal('step3[jewellery_center_stone]');
        var jewelleryCenterStoneOther = getVal('step3[jewellery_center_stone_other]');
        var jewellerySideStones = getVal('step3[jewellery_side_stones]');
        var jewellerySideStonesOther = getVal('step3[jewellery_side_stones_other]');
        var isWatchOther = watchBrand && /\bother\b/i.test(watchBrand);
        var isMetalOther = jewelleryMetal && /\bother\b/i.test(jewelleryMetal);
        var watchBrandVal = (isWatchOther && watchBrandOther) ? watchBrandOther : watchBrand;
        var metalVal = (isMetalOther && jewelleryMetalOther) ? jewelleryMetalOther : jewelleryMetal;
        out.brand = watchBrandVal || metalVal;
        out.model = getVal('step3[watch_model]');
        var jewelryTypeSelect = getVal('step3[jewellery_type]') || getVal('step3[jewelry_services_type]');
        var jewelryTypeOther = getVal('step3[jewelry_services_type_other]');
        var isJewelryTypeOther = jewelryTypeSelect && /\bother\b/i.test(jewelryTypeSelect);
        var isCenterStoneOther = jewelleryCenterStone && /\bother\b/i.test(jewelleryCenterStone);
        var isSideStonesOther = jewellerySideStones && /\bother\b/i.test(jewellerySideStones);
        out.jewelryType = (isJewelryTypeOther && jewelryTypeOther) ? jewelryTypeOther : (jewelryTypeSelect || jewelryTypeOther);
        out.metal = (isMetalOther && jewelleryMetalOther) ? jewelleryMetalOther : jewelleryMetal;
        out.centerStone = (isCenterStoneOther && jewelleryCenterStoneOther) ? jewelleryCenterStoneOther : jewelleryCenterStone;
        out.centerCarat = getVal('step3[jewellery_center_carat]');
        out.sideStones = (isSideStonesOther && jewellerySideStonesOther) ? jewellerySideStonesOther : jewellerySideStones;
        var skipNames = { 'step3[watch_tell_more]': 1, 'step3[watch_declared_value]': 1, 'step3[watch_brand]': 1, 'step3[watch_brand_other]': 1, 'step3[jewellery_tell_more]': 1, 'step3[jewellery_declared_value]': 1, 'step3[jewellery_metal]': 1, 'step3[jewellery_metal_other]': 1, 'step3[jewellery_center_stone]': 1, 'step3[jewellery_center_stone_other]': 1, 'step3[jewellery_side_stones]': 1, 'step3[jewellery_side_stones_other]': 1, 'step3[jewelry_services_additional]': 1, 'step3[jewelry_services_type]': 1, 'step3[jewelry_services_type_other]': 1 };
        if (out.metal) out.extraFields.push({ label: 'Metal', value: out.metal, groupHeading: null, groupType: null, isCheckbox: false });
        if (out.centerStone) out.extraFields.push({ label: 'Center stone', value: out.centerStone, groupHeading: null, groupType: null, isCheckbox: false });
        if (out.sideStones) out.extraFields.push({ label: 'Side stones', value: out.sideStones, groupHeading: null, groupType: null, isCheckbox: false });
        for (var pi = 0; pi < panels.length; pi++) {
          var panel = panels[pi];
          var additionalHeading = panel.getAttribute('data-additional-services-heading') || 'Additional Services';
          var watchProblemsHeading = panel.getAttribute('data-watch-problems-heading') || 'Common Watch Problems';
          panel.querySelectorAll('.multi-stepper-form__field input, .multi-stepper-form__field textarea, .multi-stepper-form__field select, .multi-stepper-form__field-group input').forEach(function(inp) {
            var name = inp.name;
            if (!name || skipNames[name]) return;
            var reviewLabelEl = inp.closest('[data-review-label]');
            var reviewLabel = reviewLabelEl ? reviewLabelEl.getAttribute('data-review-label') : null;
            var fieldEl = inp.closest('.multi-stepper-form__field');
            var labelEl = panel.querySelector('label[for="' + inp.id + '"]') || (fieldEl && fieldEl.querySelector('label')) || inp.closest('label');
            var label = (reviewLabel && reviewLabel.trim()) || (labelEl ? (labelEl.innerText || labelEl.textContent || '').replace(/\s*\*?\s*$/, '').trim() : '') || name;
            var val = inp.type === 'checkbox' ? (inp.checked ? inp.value : '') : (inp.value || '').trim();
            var groupHeading = null;
            var groupType = null;
            var groupEl = inp.closest('.multi-stepper-form__field-group');
            var wrapEl = inp.closest('.multi-stepper-form__service-text-wrap');
            if (groupEl) {
              groupHeading = groupEl.getAttribute('data-group-heading') || '';
              groupType = groupEl.getAttribute('data-group-type') || '';
            } else if (wrapEl) {
              groupHeading = wrapEl.getAttribute('data-group-heading') || additionalHeading;
              groupType = wrapEl.getAttribute('data-group-type') || 'additional-services';
            }
            if (label) out.extraFields.push({ label: label, value: val, groupHeading: groupHeading || null, groupType: groupType || null, isCheckbox: inp.type === 'checkbox' });
          });
        }
      }
      return out;
    }

    function renderReview() {
      var reviewEl = root.querySelector('[data-review]');
      if (!reviewEl) return;
      reviewImageUrls.forEach(function(url) { URL.revokeObjectURL(url); });
      reviewImageUrls = [];
      var vals = getStep3ValuesFromDOM();

      var itemEl = reviewEl.querySelector('[data-review-item]');
      if (itemEl) itemEl.textContent = vals.item || '—';

      var tellEl = reviewEl.querySelector('[data-review-tell-more]');
      if (tellEl) tellEl.textContent = vals.tellMore || '—';

      var declEl = reviewEl.querySelector('[data-review-declared-value]');
      if (declEl) declEl.textContent = vals.declaredValue ? ((vals.declaredValueCurrency || '$') + vals.declaredValue) : '—';

      var brandEl = reviewEl.querySelector('[data-review-brand]');
      var brandWrap = reviewEl.querySelector('[data-review-brand-wrap]');
      if (brandEl) brandEl.textContent = vals.brand || '—';
      if (brandWrap) {
        var itemLower = (vals.item || '').toLowerCase();
        brandWrap.style.display = itemLower.indexOf('watch') >= 0 ? '' : 'none';
      }

      var additionalEl = reviewEl.querySelector('[data-review-additional-services]');
      if (additionalEl) {
        additionalEl.innerHTML = '';
        var addItems = vals.extraFields.filter(function(f) { return f.groupType === 'additional-services' && f.value; });
        if (addItems.length > 0) {
          var addHeading = addItems[0].groupHeading || 'Additional Services';
          var h = document.createElement('h4');
          h.className = 'multi-stepper-form__review-section-heading';
          h.textContent = addHeading;
          additionalEl.appendChild(h);
          var serviceLabels = addItems.filter(function(f) { return f.value === 'Yes'; }).map(function(f) { return f.label; });
          var textItems = addItems.filter(function(f) { return f.value !== 'Yes'; });
          if (serviceLabels.length > 0) {
            var servicesLine = document.createElement('div');
            servicesLine.className = 'multi-stepper-form__review-names-inline';
            servicesLine.textContent = serviceLabels.join(', ');
            additionalEl.appendChild(servicesLine);
          }
          textItems.forEach(function(f) {
            var textLine = document.createElement('div');
            textLine.className = 'multi-stepper-form__review-text-line';
            textLine.innerHTML = '<span class="multi-stepper-form__review-label">Text:</span> <span class="multi-stepper-form__review-value">' + esc(f.value) + '</span>';
            additionalEl.appendChild(textLine);
          });
        }
      }
      var commonEl = reviewEl.querySelector('[data-review-common-watch]');
      if (commonEl) {
        commonEl.innerHTML = '';
        var watchItems = vals.extraFields.filter(function(f) { return f.groupType === 'watch-problems' && f.value; });
        if (watchItems.length > 0) {
          var watchHeading = watchItems[0].groupHeading || 'Common Watch Problems';
          var h = document.createElement('h4');
          h.className = 'multi-stepper-form__review-section-heading';
          h.textContent = watchHeading;
          commonEl.appendChild(h);
          var watchLabels = watchItems.map(function(f) { return f.label; });
          var problemsLine = document.createElement('div');
          problemsLine.className = 'multi-stepper-form__review-names-inline';
          problemsLine.textContent = watchLabels.join(', ');
          commonEl.appendChild(problemsLine);
        }
      }
      var servicesAdditionalEl = reviewEl.querySelector('[data-review-services-additional]');
      if (servicesAdditionalEl) {
        servicesAdditionalEl.innerHTML = '';
        var promptItems = vals.extraFields.filter(function(f) { return f.groupType === 'jewelry-services-prompts' && f.value && !f.isCheckbox; });
        if (promptItems.length === 0) {
          var jewelryPromptConfig = [
            { name: 'step3[jewelry_services_sizing_text]', label: 'What size are you requesting' },
            { name: 'step3[jewelry_services_sizing_balls_text]', label: 'What balls sizing are you requesting' },
            { name: 'step3[jewelry_services_engraving_text]', label: 'What needs to be engraved' },
            { name: 'step3[jewelry_services_chain_extender_text]', label: 'How many inches are needed to be extended' },
            { name: 'step3[jewelry_services_other_text]', label: 'Please describe the service needed' }
          ];
          jewelryPromptConfig.forEach(function(cfg) {
            var inp = root.querySelector('[name="' + cfg.name + '"]');
            var v = inp ? (inp.value || '').trim() : '';
            if (v) promptItems.push({ label: cfg.label, value: v });
          });
        }
        var jewelryAdditionalInfo = (vals.jewelryAdditionalInfo || '').trim();
        var jewelryType = (vals.jewelryType || '').trim();
        var hasContent = promptItems.length > 0 || jewelryAdditionalInfo || jewelryType;
        if (hasContent) {
          var h = document.createElement('h4');
          h.className = 'multi-stepper-form__review-section-heading';
          h.textContent = reviewEl.getAttribute('data-services-additional-heading') || 'Services additional information';
          servicesAdditionalEl.appendChild(h);
          var grid = document.createElement('div');
          grid.className = 'multi-stepper-form__review-services-additional-grid';
          if (jewelryType) {
            var jewelryTypeLabel = reviewEl.getAttribute('data-jewelry-type-label') || 'Type of Jewelry';
            var jewelryTypeItem = document.createElement('div');
            jewelryTypeItem.className = 'multi-stepper-form__review-field';
            jewelryTypeItem.innerHTML = '<span class="multi-stepper-form__review-label">' + esc(jewelryTypeLabel) + '</span><span class="multi-stepper-form__review-value">' + esc(jewelryType) + '</span>';
            grid.appendChild(jewelryTypeItem);
          }
          promptItems.forEach(function(f) {
            var item = document.createElement('div');
            item.className = 'multi-stepper-form__review-field';
            item.innerHTML = '<span class="multi-stepper-form__review-label">' + esc(f.label) + '</span><span class="multi-stepper-form__review-value">' + esc(f.value) + '</span>';
            grid.appendChild(item);
          });
          if (jewelryAdditionalInfo) {
            var addInfoLabel = reviewEl.getAttribute('data-additional-info-heading') || 'Additional Information';
            var addInfoItem = document.createElement('div');
            addInfoItem.className = 'multi-stepper-form__review-field';
            addInfoItem.innerHTML = '<span class="multi-stepper-form__review-label">' + esc(addInfoLabel) + '</span><span class="multi-stepper-form__review-value">' + esc(jewelryAdditionalInfo) + '</span>';
            grid.appendChild(addInfoItem);
          }
          servicesAdditionalEl.appendChild(grid);
        }
      }
      var extraEl = reviewEl.querySelector('[data-review-extra]');
      if (extraEl) {
        extraEl.innerHTML = '';
        vals.extraFields.filter(function(f) { return !f.groupType && f.value; }).forEach(function(f) {
          var row = document.createElement('div');
          row.className = 'multi-stepper-form__review-field';
          row.innerHTML = '<span class="multi-stepper-form__review-label">' + esc(f.label) + '</span><span class="multi-stepper-form__review-value">' + esc(f.value) + '</span>';
          extraEl.appendChild(row);
        });
      }

      var refImagesByService = {};
      root.querySelectorAll('[data-reference-upload-input]').forEach(function(inp) {
        var b = (inp._isPdf && inp._previewJpegBlob) ? inp._previewJpegBlob : (inp._compressedBlob || (inp.files && inp.files[0]));
        if (!b) return;
        var sid = inp.getAttribute('data-reference-service-id') || '';
        var stitle = inp.getAttribute('data-reference-service-title') || '';
        var key = sid || stitle;
        if (key) refImagesByService[key] = b;
      });
      var listEl = reviewEl.querySelector('[data-review-services-list]');
      var emptyEl = reviewEl.querySelector('[data-review-services-empty]');
      var totalWrap = reviewEl.querySelector('[data-review-total-wrap]');
      if (listEl) {
        var jewelryItems = vals.extraFields.filter(function(f) { return f.groupType === 'jewelry-services' && f.value; });
        var servicesToShow = vals.services.slice();
        jewelryItems.forEach(function(f) { servicesToShow.push({ title: f.value, description: '' }); });
        root.querySelectorAll('[data-jewelry-services-checkboxes] input[type="checkbox"]:checked').forEach(function(cb) {
          var svc = (cb.value || '').trim();
          if (svc && servicesToShow.every(function(s) { return s.title !== svc; })) servicesToShow.push({ title: svc, description: '' });
        });
        if (servicesToShow.length === 0) {
          if (emptyEl) emptyEl.style.display = '';
          listEl.querySelectorAll('li:not([data-review-services-empty])').forEach(function(li) { li.remove(); });
        } else {
          if (emptyEl) emptyEl.style.display = 'none';
          listEl.querySelectorAll('li:not([data-review-services-empty])').forEach(function(li) { li.remove(); });
          servicesToShow.forEach(function(s) {
            var li = document.createElement('li');
            li.className = 'multi-stepper-form__review-service-item';
            var left = '<span class="multi-stepper-form__review-service-left">' + esc(s.title);
            if (s.description) left += '<span class="multi-stepper-form__review-service-desc">' + esc(s.description) + '</span>';
            left += '</span>';
            li.innerHTML = left;
            var refBlob = refImagesByService[s.id] || refImagesByService[s.title];
            if (refBlob) {
              var url = URL.createObjectURL(refBlob);
              reviewImageUrls.push(url);
              var thumbWrap = document.createElement('span');
              thumbWrap.className = 'multi-stepper-form__review-service-ref-thumb';
              var img = document.createElement('img');
              img.className = 'multi-stepper-form__review-thumb';
              img.src = url;
              img.alt = '';
              thumbWrap.appendChild(img);
              li.querySelector('.multi-stepper-form__review-service-left').appendChild(thumbWrap);
            }
            listEl.appendChild(li);
          });
          if (totalWrap) totalWrap.style.display = 'flex';
        }
      }

      var imagesContainer = reviewEl.querySelector('[data-review-images]');
      var imagesEmpty = reviewEl.querySelector('[data-review-images-empty]');
      if (imagesContainer && imagesEmpty) {
        imagesContainer.querySelectorAll('img.multi-stepper-form__review-thumb').forEach(function(img) { img.remove(); });
        var blobs = [];
        root.querySelectorAll('[data-image-uploads] [data-upload-input]').forEach(function(inp) {
          if (!inp.name) return;
          var b;
          if (inp._isPdf && inp._previewJpegBlob) b = inp._previewJpegBlob;
          else if (!inp._isPdf) b = inp._compressedBlob || (inp.files && inp.files[0]);
          if (b) blobs.push(b);
        });
        var additionalRow = root.querySelector('[data-additional-row]');
        if (additionalRow && additionalRow._additionalSlots) {
          additionalRow._additionalSlots.forEach(function(slot) {
            if (!slot) return;
            var b = slot.isPdf ? slot.previewBlob : slot.blob;
            if (b) blobs.push(b);
          });
        }
        if (blobs.length === 0) {
          imagesEmpty.style.display = '';
        } else {
          imagesEmpty.style.display = 'none';
          blobs.forEach(function(blob) {
            var url = URL.createObjectURL(blob);
            reviewImageUrls.push(url);
            var img = document.createElement('img');
            img.className = 'multi-stepper-form__review-thumb';
            img.src = url;
            img.alt = '';
            imagesContainer.appendChild(img);
          });
        }
      }
    }

    function isRequiredFilled(inp) {
      if (!inp) return true;
      if (inp.type === 'checkbox' || inp.type === 'radio') {
        var req = inp.hasAttribute('required') || inp.hasAttribute('data-required');
        return !req || inp.checked;
      }
      if (inp.type === 'file') return (inp.files && inp.files[0]) || inp._compressedBlob;
      var v = (inp.value || '').trim();
      if (v === '') return false;
      if ((inp.type === 'email' || inp.type === 'tel') && inp.checkValidity) {
        return inp.checkValidity();
      }
      return true;
    }

    function getStepElement(stepNum) {
      return root.querySelector('.multi-stepper-form__step--' + stepNum) || root.querySelector('.multi-stepper-form__step[data-step="' + stepNum + '"]');
    }

    function allRequiredFilledInStep(stepNum) {
      var stepEl = getStepElement(stepNum);
      if (!stepEl) return false;
      if (stepNum === 1) {
        if (!selectedItemLabel) return false;
      }
      if (stepNum === 2) {
        var key = norm(selectedItemLabel);
        var anyService = false;
        root.querySelectorAll('.multi-stepper-form__service-check').forEach(function(x) {
          if (!x.checked) return;
          var c = x.closest('.multi-stepper-form__service-card');
          if (!c) { anyService = true; return; }
          var cardLabel = (c.getAttribute('data-item-label') || '').trim();
          if (cardLabel === '' || norm(cardLabel) === key) anyService = true;
        });
        if (!anyService) {
          var jewelryGroup = stepEl.querySelector('[data-jewelry-services-group][data-jewelry-services-visible]');
          if (jewelryGroup) {
            var jewelryCbs = jewelryGroup.querySelectorAll('input[type="checkbox"]');
            for (var jc = 0; jc < jewelryCbs.length; jc++) { if (jewelryCbs[jc].checked) { anyService = true; break; } }
          }
        }
        if (!anyService) return false;
      }
      var visiblePanel = stepEl.querySelector('.multi-stepper-form__item-details[data-item-details-panel]:not([hidden])');
      var required = [];
      if (visiblePanel) {
        visiblePanel.querySelectorAll('input, textarea, select').forEach(function(inp) {
          if (inp.hasAttribute('required') || inp.hasAttribute('data-required')) required.push(inp);
        });
      }
      stepEl.querySelectorAll('.multi-stepper-form__step3-field').forEach(function(field) {
        if (field.style.display === 'none') return;
        field.querySelectorAll('input, textarea, select').forEach(function(inp) {
          if (inp.hasAttribute('required') || inp.hasAttribute('data-required')) required.push(inp);
        });
      });
      stepEl.querySelectorAll('input, textarea, select').forEach(function(inp) {
        var inHiddenPanel = inp.closest('.multi-stepper-form__item-details[data-item-details-panel][hidden]');
        if (inHiddenPanel) return;
        if ((inp.hasAttribute('required') || inp.hasAttribute('data-required')) && required.indexOf(inp) === -1) required.push(inp);
      });
      for (var j = 0; j < required.length; j++) {
        if (!isRequiredFilled(required[j])) return false;
      }
      var requireOneGroups = stepEl.querySelectorAll('[data-require-one-from-group]');
      for (var r = 0; r < requireOneGroups.length; r++) {
        var group = requireOneGroups[r];
        if (group.closest && group.closest('[hidden]')) continue;
        var parentGroup = group.closest && group.closest('[data-jewelry-services-group]');
        if (parentGroup && !parentGroup.hasAttribute('data-jewelry-services-visible')) continue;
        var cbs = group.querySelectorAll('input[type="checkbox"]');
        var anyChecked = false;
        for (var c = 0; c < cbs.length; c++) { if (cbs[c].checked) { anyChecked = true; break; } }
        if (!anyChecked) return false;
      }
      var requiredUploads = stepEl.querySelectorAll('[data-image-uploads] input[data-upload-required]');
      for (var k = 0; k < requiredUploads.length; k++) {
        var ru = requiredUploads[k];
        if (!(ru.files && ru.files[0]) && !ru._compressedBlob) return false;
      }
      var confirmVerify = stepEl.querySelector('[data-confirmation-email-verify]');
      if (confirmVerify) {
        var contactEmailInp = root.querySelector('[name="step3[contact_email]"]');
        var contactEmail = contactEmailInp ? (contactEmailInp.value || '').trim() : '';
        var confirmEmail = (confirmVerify.value || '').trim();
        if (confirmEmail.toLowerCase() !== contactEmail.toLowerCase()) return false;
      }
      return true;
    }

    function updateNextButtonForStep(stepNum) {
      var stepEl = getStepElement(stepNum);
      if (!stepEl) return;
      var filled = allRequiredFilledInStep(stepNum);
      stepEl.querySelectorAll('[data-next-step]').forEach(function(btn) {
        btn.disabled = !filled;
      });
      var submitBtnInStep = stepEl.querySelector('.multi-stepper-form__btn--submit') || stepEl.querySelector('[data-confirmation-submit]') || stepEl.querySelector('button[type="submit"]');
      if (submitBtnInStep) submitBtnInStep.disabled = !filled;
      if (submitBtn && (stepNum === 3 || stepNum === 4)) submitBtn.disabled = !filled;
    }

    function updateImageUploadStepButton() {
      var imageUploadsEl = root.querySelector('[data-image-uploads]');
      var stepEl = imageUploadsEl && imageUploadsEl.closest('[class*="multi-stepper-form__step--"]');
      if (stepEl) {
        var m = stepEl.className && stepEl.className.match(STEP_REGEX);
        var stepNum = m ? parseInt(m[1], 10) : null;
        if (stepNum != null) updateNextButtonForStep(stepNum);
      } else {
        updateNextButtonForStep(3);
      }
    }

    card.addEventListener('click', onCardClick);
    var serviceList = root.querySelector('[data-service-list]');
    if (serviceList) serviceList.addEventListener('click', onServiceListClick);
    function onServiceCheckChange() {
      setTimeout(function() {
        updateNextButtonForStep(2);
        updateReferenceUploadSections();
        renderReview();
      }, 0);
    }
    root.addEventListener('change', function(e) {
      if (e.target && e.target.classList && e.target.classList.contains('multi-stepper-form__service-check')) onServiceCheckChange();
    });
    root.addEventListener('click', function(e) {
      if (e.target && e.target.closest && e.target.closest('.multi-stepper-form__service-card')) onServiceCheckChange();
    });

    function getStepNumberFromElement(el) {
      var stepEl = el && el.closest && el.closest('[class*="multi-stepper-form__step--"]');
      if (!stepEl) return null;
      var m = stepEl.className && stepEl.className.match(STEP_REGEX);
      return m ? parseInt(m[1], 10) : null;
    }
    function onStepInputOrChange(e) {
      var t = e.target;
      if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT')) {
        if (typeof clearFieldError === 'function') clearFieldError(t);
        if (t.getAttribute('data-confirmation-email-verify') !== null) t.setCustomValidity && t.setCustomValidity('');
      }
      if (t && t.getAttribute('data-confirmation-email-verify') !== null) {
        setTimeout(function() {
          var stepNum = getStepNumberFromElement(t);
          if (stepNum != null) updateNextButtonForStep(stepNum);
          else updateConfirmationSubmitButton();
        }, 0);
        return;
      }
      var stepNum = getStepNumberFromElement(t);
      if (stepNum != null) {
        setTimeout(function() {
          updateNextButtonForStep(stepNum);
          if (stepNum >= 2 && stepNum <= 5) renderReview();
        }, 0);
      }
    }
    root.addEventListener('input', onStepInputOrChange);
    root.addEventListener('change', onStepInputOrChange);
    root.addEventListener('blur', function(e) {
      var t = e.target;
      if (!t || (t.tagName !== 'INPUT' && t.tagName !== 'TEXTAREA' && t.tagName !== 'SELECT')) return;
      if (!t.getAttribute('aria-describedby')) return;
      if (typeof clearFieldError !== 'function' || typeof showFieldError !== 'function') return;
      if (t.getAttribute('data-confirmation-email-verify') !== null) {
        t.setCustomValidity('');
        if (!t.checkValidity()) {
          showFieldError(t, t.validationMessage || 'Please enter a valid email address.');
          return;
        }
        var contactEmailInp = root.querySelector('[name="step3[contact_email]"]');
        var contactEmail = contactEmailInp ? (contactEmailInp.value || '').trim() : '';
        var confirmEmail = (t.value || '').trim();
        if (confirmEmail && contactEmail && confirmEmail.toLowerCase() !== contactEmail.toLowerCase()) {
          t.setCustomValidity('Email addresses must match');
          showFieldError(t, 'Email addresses must match.');
          return;
        }
      }
      if ((t.hasAttribute('required') || t.hasAttribute('data-required')) && t.checkValidity && !t.checkValidity()) {
        showFieldError(t, t.validationMessage || 'Please fill in this field.');
      } else {
        clearFieldError(t);
      }
    }, true);
    function toggleSelectOtherWrap(selectEl) {
      if (!selectEl || !selectEl.hasAttribute('data-select-has-other')) return;
      var selectId = selectEl.id;
      if (!selectId) return;
      var wrap = root.querySelector('[data-select-other-wrap][data-select-for="' + selectId + '"]');
      var otherInp = wrap ? wrap.querySelector('[data-select-other-input]') : null;
      var selVal = (selectEl.value || '').trim();
      var isOther = (selVal && /\bother\b/i.test(selVal));
      if (wrap) wrap.style.display = isOther ? '' : 'none';
      if (otherInp) {
        if (isOther) otherInp.setAttribute('required', 'required');
        else { otherInp.removeAttribute('required'); otherInp.value = ''; }
      }
    }
    root.querySelectorAll('select[data-select-has-other]').forEach(toggleSelectOtherWrap);
    root.addEventListener('change', function(e) {
      if (e.target && e.target.tagName === 'SELECT' && e.target.hasAttribute('data-select-has-other')) {
        toggleSelectOtherWrap(e.target);
        setTimeout(function() { var sn = getStepNumberFromElement(e.target); updateNextButtonForStep(sn); if (sn >= 2 && sn <= 5) renderReview(); }, 0);
      }
    });
    root.addEventListener('change', function(e) {
      if (e.target && e.target.getAttribute('data-service-has-text') !== null) {
        var panel = e.target.closest('.multi-stepper-form__item-details');
        if (!panel) return;
        var key = e.target.getAttribute('data-service-key');
        var wrap = key ? panel.querySelector('[data-service-text-wrap][data-service-key="' + key + '"]') : null;
        var textarea = key ? panel.querySelector('[data-service-textarea][data-service-key="' + key + '"]') : null;
        if (wrap) wrap.hidden = !e.target.checked;
        if (textarea) {
          if (e.target.checked) textarea.setAttribute('required', 'required');
          else {
            textarea.removeAttribute('required');
            textarea.value = '';
          }
        }
      }
    });
    root.addEventListener('input', function(e) {
      var t = e.target;
      if (!t) return;
      var allowed;
      if (t.getAttribute('data-declared-value-input') !== null || t.getAttribute('data-center-carat-input') !== null) {
        allowed = sanitizeInput(t.value, 'numeric');
        if (allowed !== t.value) t.value = allowed;
      } else if (t.getAttribute('data-phone-input') !== null) {
        allowed = sanitizeInput(t.value, 'phone');
        if (allowed !== t.value) t.value = allowed;
      }
    });
    root.addEventListener('paste', function(e) {
      var target = e.target;
      if (!target) return;
      var attr = target.getAttribute('data-phone-input') !== null ? 'phone' : (target.getAttribute('data-center-carat-input') !== null ? 'numeric' : null);
      if (attr) {
        setTimeout(function() {
          var allowed = sanitizeInput(target.value, attr);
          if (allowed !== target.value) target.value = allowed;
        }, 0);
      }
    });

    function blobToBase64(blob) {
      return new Promise(function(resolve, reject) {
        if (!blob) return resolve('');
        var reader = new FileReader();
        reader.onload = function() {
          var dataUrl = reader.result;
          var base64 = dataUrl.indexOf(',') >= 0 ? dataUrl.split(',')[1] : dataUrl;
          resolve(base64 || '');
        };
        reader.onerror = function() { reject(reader.error); };
        reader.readAsDataURL(blob);
      });
    }

    function pdfFirstPageToJpegBlob(file, maxWidth, quality, done) {
      if (typeof pdfjsLib === 'undefined' || !file) return done(new Error('PDF.js not loaded'));
      if (typeof done !== 'function') done = function() {};
      ensurePdfWorker();
      file.arrayBuffer().then(function(arrayBuffer) {
        pdfjsLib.getDocument({ data: arrayBuffer }).promise.then(function(pdf) {
          return pdf.getPage(1);
        }).then(function(page) {
          var scale = 2.5;
          var viewport = page.getViewport({ scale: scale });
          var maxDim = maxWidth || 1600;
          if (viewport.width > maxDim) {
            scale = maxDim / viewport.width;
            viewport = page.getViewport({ scale: scale });
          }
          var canvas = document.createElement('canvas');
          var ctx = canvas.getContext('2d');
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          return page.render({ canvasContext: ctx, viewport: viewport }).promise.then(function() {
            return new Promise(function(resolve) {
              canvas.toBlob(function(blob) { resolve(blob); }, 'image/jpeg', quality || 0.95);
            });
          });
        }).then(function(blob) {
          done(null, blob);
        }).catch(function(err) {
          done(err || new Error('PDF render failed'));
        });
      }).catch(function(err) {
        done(err || new Error('Could not read PDF'));
      });
    }

    function setPreviewFromBlob(previewImg, previewBox, blob, alt, isPdf, pdfPreviewEl) {
      if (previewImg && previewImg._prevUrl) {
        URL.revokeObjectURL(previewImg._prevUrl);
        previewImg._prevUrl = null;
      }
      previewBox.classList.remove('has-pdf');
      if (pdfPreviewEl) { pdfPreviewEl.textContent = ''; pdfPreviewEl.style.display = 'none'; }
      if (previewImg) {
        previewImg.removeAttribute('src');
        previewImg.alt = '';
      }
      if (isPdf && pdfPreviewEl) {
        pdfPreviewEl.textContent = alt || 'PDF';
        pdfPreviewEl.style.display = 'flex';
        previewBox.classList.add('has-preview', 'has-pdf');
      } else if (previewImg && blob) {
        var url = URL.createObjectURL(blob);
        previewImg._prevUrl = url;
        previewImg.src = url;
        previewImg.alt = alt || 'Preview';
        previewBox.classList.add('has-preview');
      }
      previewBox.classList.remove('is-loading');
    }

    function clearPreview(previewImg, previewBox, pdfPreviewEl) {
      if (previewImg && previewImg._prevUrl) {
        URL.revokeObjectURL(previewImg._prevUrl);
        previewImg._prevUrl = null;
      }
      if (previewImg) {
        previewImg.removeAttribute('src');
        previewImg.alt = '';
      }
      if (pdfPreviewEl) { pdfPreviewEl.textContent = ''; pdfPreviewEl.style.display = 'none'; }
      previewBox.classList.remove('has-preview', 'has-pdf', 'is-loading');
    }

    function showUploadError(item, msg) {
      var errEl = item && item.querySelector('[data-upload-error]');
      if (errEl) { errEl.textContent = msg || ''; errEl.style.display = msg ? '' : 'none'; }
    }

    function compressImageBlob(blob, maxSize, maxDim, quality, done) {
      var url = URL.createObjectURL(blob);
      var img = new Image();
      img.onload = function() {
        URL.revokeObjectURL(url);
        var w = img.naturalWidth || img.width;
        var h = img.naturalHeight || img.height;
        if (maxDim && (w > maxDim || h > maxDim)) {
          if (w > h) { h = Math.round(h * maxDim / w); w = maxDim; }
          else { w = Math.round(w * maxDim / h); h = maxDim; }
        }
        var canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, w, h);
        var q = quality;
        function tryBlob() {
          canvas.toBlob(function(result) {
            if (result && result.size <= maxSize) return done(null, result);
            if (q <= 0.4) return done(null, result || blob);
            q = Math.max(0.4, q - 0.15);
            tryBlob();
          }, 'image/jpeg', q);
        }
        tryBlob();
      };
      img.onerror = function() { URL.revokeObjectURL(url); done(new Error('Invalid image')); };
      img.src = url;
    }

    function processFileForPreview(inp, file, item, previewImg, previewBox) {
      var pdfPreviewEl = previewBox.querySelector && previewBox.querySelector('[data-pdf-preview]');
      var fileName = file.name || 'image';
      var baseName = fileName.replace(/\.[^.]+$/, '') || 'image';
      function finish(blob, isCompressed) {
        if (blob && blob.size > MAX_IMAGE_SIZE) {
          showUploadError(item, 'Image must be under 20 MB. Try a smaller or more compressed image.');
          clearPreview(previewImg, previewBox, pdfPreviewEl);
          inp.value = '';
          inp._compressedBlob = null;
          inp._compressedFileName = null;
          inp._isPdf = false;
        } else if (blob) {
          showUploadError(item, '');
          setPreviewFromBlob(previewImg, previewBox, blob, fileName, false, pdfPreviewEl);
          if (isCompressed) {
            inp._compressedBlob = blob;
            inp._compressedFileName = baseName + '.jpg';
            inp._isPdf = false;
          } else {
            inp._compressedBlob = null;
            inp._compressedFileName = null;
          }
        }
        setTimeout(function() { updateImageUploadStepButton(); renderReview(); }, 0);
      }
      function tryCompress(blob) {
        compressImageBlob(blob, MAX_IMAGE_SIZE, 1920, 0.85, function(err, compressed) {
          if (err) return finish(blob, false);
          finish(compressed || blob, true);
        });
      }
      if (isHeicFile(file) && typeof heic2any === 'function') {
        heic2any({ blob: file, toType: 'image/jpeg', quality: 0.85 }).then(function(converted) {
          var blob = Array.isArray(converted) ? converted[0] : converted;
          if (!blob) return finish(null);
          if (blob.size <= MAX_IMAGE_SIZE) return finish(blob, true);
          tryCompress(blob);
        }).catch(function() {
          showUploadError(item, 'Could not process HEIC image.');
          clearPreview(previewImg, previewBox, pdfPreviewEl);
          inp.value = '';
          inp._compressedBlob = null;
          inp._isPdf = false;
          setTimeout(updateImageUploadStepButton, 0);
        });
        return;
      }
      if (isPdfFile(file)) {
        if (file.size > MAX_IMAGE_SIZE) {
          showUploadError(item, 'PDF must be under 20 MB.');
          clearPreview(previewImg, previewBox, pdfPreviewEl);
          inp.value = '';
          inp._compressedBlob = null;
          inp._compressedFileName = null;
        } else {
          showUploadError(item, '');
          inp._compressedBlob = file;
          inp._compressedFileName = file.name || 'document.pdf';
          inp._isPdf = true;
          inp._previewJpegBlob = null;
          pdfFirstPageToJpegBlob(file, 1600, 0.95, function(err, jpegBlob) {
            if (!err && jpegBlob) {
              if (jpegBlob.size > MAX_IMAGE_SIZE) {
                compressImageBlob(jpegBlob, MAX_IMAGE_SIZE, 1920, 0.9, function(compressErr, compressed) {
                  inp._previewJpegBlob = compressed || jpegBlob;
                  setPreviewFromBlob(previewImg, previewBox, inp._previewJpegBlob, fileName, false, pdfPreviewEl);
                  setTimeout(function() { updateImageUploadStepButton(); renderReview(); }, 0);
                });
              } else {
                inp._previewJpegBlob = jpegBlob;
                setPreviewFromBlob(previewImg, previewBox, jpegBlob, fileName, false, pdfPreviewEl);
                setTimeout(function() { updateImageUploadStepButton(); renderReview(); }, 0);
              }
            } else {
              setPreviewFromBlob(previewImg, previewBox, null, fileName, true, pdfPreviewEl);
              setTimeout(function() { updateImageUploadStepButton(); renderReview(); }, 0);
            }
          });
        }
        return;
      }
      if (!file.type || file.type.indexOf('image/') !== 0) {
        showUploadError(item, 'Please select an image or PDF file.');
        clearPreview(previewImg, previewBox, pdfPreviewEl);
        inp._compressedBlob = null;
        inp._isPdf = false;
        setTimeout(updateImageUploadStepButton, 0);
        return;
      }
      tryCompress(file);
    }

    function setupDropZone(dropZone, inp, item, previewImg, isRequired) {
      var pdfPreviewEl = dropZone.querySelector && dropZone.querySelector('[data-pdf-preview]');
      var removeBtn = dropZone.querySelector && dropZone.querySelector('[data-single-remove]');
      function handleFile(file) {
        var isImage = file && file.type && file.type.indexOf('image/') === 0;
        var isPdf = file && isPdfFile(file);
        if (!file || (!isImage && !isPdf)) {
          if (file) showUploadError(item, 'Please select an image or PDF file.');
          clearPreview(previewImg, dropZone, pdfPreviewEl);
          inp._compressedBlob = null;
          inp._compressedFileName = null;
          inp._isPdf = false;
          inp.value = '';
          setTimeout(updateImageUploadStepButton, 0);
          return;
        }
        dropZone.classList.add('is-loading');
        showUploadError(item, '');
        processFileForPreview(inp, file, item, previewImg, dropZone);
      }
      if (removeBtn) {
        removeBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          clearPreview(previewImg, dropZone, pdfPreviewEl);
          inp.value = '';
          inp._compressedBlob = null;
          inp._compressedFileName = null;
          inp._isPdf = false;
          inp._previewJpegBlob = null;
          setTimeout(function() { updateImageUploadStepButton(); renderReview(); }, 0);
        });
      }
      dropZone.addEventListener('click', function(e) {
        if (e.target === removeBtn) return;
        e.preventDefault();
        inp.click();
      });
      inp.addEventListener('change', function() {
        var file = inp.files && inp.files[0];
        if (!file) {
          clearPreview(previewImg, dropZone, dropZone.querySelector('[data-pdf-preview]'));
          inp._compressedBlob = null;
          inp._compressedFileName = null;
          inp._isPdf = false;
          inp._previewJpegBlob = null;
          setTimeout(function() { updateImageUploadStepButton(); renderReview(); }, 0);
          return;
        }
        handleFile(file);
      });
      dropZone.addEventListener('dragover', function(e) {
        e.preventDefault();
        e.stopPropagation();
        dropZone.classList.add('is-dragover');
      });
      dropZone.addEventListener('dragleave', function(e) {
        e.preventDefault();
        dropZone.classList.remove('is-dragover');
      });
      dropZone.addEventListener('drop', function(e) {
        e.preventDefault();
        e.stopPropagation();
        dropZone.classList.remove('is-dragover');
        var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (file) handleFile(file);
      });
    }

    function initImageUploadPreviews() {
      root.querySelectorAll('[data-image-uploads] [data-upload-input]').forEach(function(inp) {
        var item = inp.closest('[data-upload-slot]');
        if (!item) return;
        var dropZone = item.querySelector('[data-drop-zone]');
        var previewImg = dropZone && dropZone.querySelector('[data-upload-preview-img]');
        if (!dropZone || !previewImg) return;
        setupDropZone(dropZone, inp, item, previewImg, inp.hasAttribute('data-upload-required'));
      });

      var additionalRow = root.querySelector('[data-additional-row]');
      var additionalInput = root.querySelector('[data-additional-input]');
      if (!additionalRow || !additionalInput) return;
      var slots = additionalRow.querySelectorAll('[data-additional-slot]');
      var slotData = [null, null, null, null];
      additionalRow._additionalSlots = slotData;

      function renderAdditionalSlots() {
        for (var i = 0; i < 4; i++) {
          var slotEl = slots[i];
          var data = slotData[i];
          var placeholder = slotEl && slotEl.querySelector('[data-drop-placeholder]');
          var previewImg = slotEl && slotEl.querySelector('[data-upload-preview-img]');
          var pdfPreview = slotEl && slotEl.querySelector('[data-pdf-preview]');
          var removeBtn = slotEl && slotEl.querySelector('[data-slot-remove]');
          if (!slotEl) continue;
          if (data && (data.url || data.isPdf)) {
            slotEl.classList.add('has-preview');
            var showPdfLabel = data.isPdf && !data.url;
            if (showPdfLabel) slotEl.classList.add('has-pdf'); else slotEl.classList.remove('has-pdf');
            slotEl.classList.remove('is-loading');
            if (data.url) {
              if (previewImg) { previewImg.src = data.url; previewImg.alt = data.fileName || ''; previewImg.style.display = ''; }
              if (pdfPreview) { pdfPreview.textContent = ''; pdfPreview.style.display = 'none'; }
            } else {
              if (previewImg) { previewImg.removeAttribute('src'); previewImg.alt = ''; previewImg.style.display = 'none'; }
              if (pdfPreview) { pdfPreview.textContent = data.fileName || 'PDF'; pdfPreview.style.display = 'flex'; }
            }
            if (placeholder) placeholder.style.display = 'none';
            if (removeBtn) removeBtn.style.display = 'flex';
          } else {
            slotEl.classList.remove('has-preview', 'has-pdf', 'is-loading');
            if (previewImg) { previewImg.removeAttribute('src'); previewImg.alt = ''; previewImg.style.display = ''; }
            if (pdfPreview) { pdfPreview.textContent = ''; pdfPreview.style.display = 'none'; }
            if (placeholder) placeholder.style.display = '';
            if (removeBtn) removeBtn.style.display = 'none';
          }
        }
        setTimeout(function() { updateImageUploadStepButton(); renderReview(); }, 0);
      }

      var replaceIndex = -1;
      function addFileToNextSlot(file, atIndex) {
        var idx = atIndex >= 0 ? atIndex : -1;
        if (idx < 0) {
          for (var i = 0; i < 4; i++) { if (!slotData[i]) { idx = i; break; } }
        }
        if (idx < 0) return;
        var slotEl = slots[idx];
        slotEl.classList.add('is-loading');
        function finish(blob, fileName, isPdf) {
          if (slotData[idx] && slotData[idx].url) URL.revokeObjectURL(slotData[idx].url);
          if (blob && isPdf) {
            slotData[idx] = { blob: blob, fileName: fileName || 'document.pdf', isPdf: true };
          } else if (blob) {
            slotData[idx] = { blob: blob, fileName: fileName || 'image.jpg', url: URL.createObjectURL(blob) };
          } else {
            slotData[idx] = null;
          }
          renderAdditionalSlots();
        }
        function tryCompress(blob) {
          compressImageBlob(blob, MAX_IMAGE_SIZE, 1920, 0.85, function(err, compressed) {
            if (err) return finish(blob, file.name, false);
            finish(compressed || blob, (file.name || '').replace(/\.[^.]+$/, '') + '.jpg', false);
          });
        }
        if (isPdfFile(file)) {
          if (file.size > MAX_IMAGE_SIZE) {
            slotData[idx] = null;
            slotEl.classList.remove('is-loading');
            renderAdditionalSlots();
            return;
          }
          pdfFirstPageToJpegBlob(file, 1600, 0.95, function(err, jpegBlob) {
            if (slotData[idx] && slotData[idx].url) URL.revokeObjectURL(slotData[idx].url);
            if (!err && jpegBlob) {
              function setSlot(blob) {
                slotData[idx] = { blob: file, fileName: file.name || 'document.pdf', isPdf: true, url: URL.createObjectURL(blob), previewBlob: blob };
                slotEl.classList.remove('is-loading');
                renderAdditionalSlots();
              }
              if (jpegBlob.size > MAX_IMAGE_SIZE) {
                compressImageBlob(jpegBlob, MAX_IMAGE_SIZE, 1920, 0.9, function(compressErr, compressed) {
                  setSlot(compressed || jpegBlob);
                });
              } else {
                setSlot(jpegBlob);
              }
            } else {
              slotData[idx] = { blob: file, fileName: file.name || 'document.pdf', isPdf: true };
              slotEl.classList.remove('is-loading');
              renderAdditionalSlots();
            }
          });
          return;
        }
        if (isHeicFile(file) && typeof heic2any === 'function') {
          heic2any({ blob: file, toType: 'image/jpeg', quality: 0.85 }).then(function(converted) {
            var blob = Array.isArray(converted) ? converted[0] : converted;
            if (!blob) return finish(null);
            if (blob.size <= MAX_IMAGE_SIZE) return finish(blob, (file.name || '').replace(/\.[^.]+$/, '') + '.jpg', false);
            tryCompress(blob);
          }).catch(function() { finish(null); });
        } else if (file.type && file.type.indexOf('image/') === 0) {
          tryCompress(file);
        } else {
          slotData[idx] = null;
          slotEl.classList.remove('is-loading');
          renderAdditionalSlots();
        }
      }

      slots.forEach(function(slotEl, idx) {
        var placeholder = slotEl.querySelector('[data-drop-placeholder]');
        var previewImg = slotEl.querySelector('[data-upload-preview-img]');
        var removeBtn = slotEl.querySelector('[data-slot-remove]');
        slotEl.addEventListener('click', function(e) {
          if (e.target === removeBtn) return;
          if (slotData[idx]) {
            replaceIndex = idx;
            additionalInput.click();
            return;
          }
          additionalInput.click();
        });
        if (removeBtn) {
          removeBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (slotData[idx] && slotData[idx].url) URL.revokeObjectURL(slotData[idx].url);
            slotData[idx] = null;
            renderAdditionalSlots();
          });
        }
        slotEl.addEventListener('dragover', function(e) {
          e.preventDefault();
          slotEl.classList.add('is-dragover');
        });
        slotEl.addEventListener('dragleave', function(e) {
          e.preventDefault();
          slotEl.classList.remove('is-dragover');
        });
        slotEl.addEventListener('drop', function(e) {
          e.preventDefault();
          slotEl.classList.remove('is-dragover');
          var files = e.dataTransfer && e.dataTransfer.files;
          if (!files || !files.length) return;
          for (var i = 0; i < Math.min(files.length, 4); i++) {
            var file = files[i];
            if (!file) continue;
            var valid = (file.type && file.type.indexOf('image/') === 0) || isPdfFile(file);
            if (replaceIndex >= 0) {
              if (valid) addFileToNextSlot(file, replaceIndex);
              replaceIndex = -1;
              break;
            }
            if (slotData[0] && slotData[1] && slotData[2] && slotData[3]) break;
            if (valid) addFileToNextSlot(file);
          }
        });
      });

      additionalInput.addEventListener('change', function() {
        var files = this.files;
        if (!files || !files.length) { replaceIndex = -1; this.value = ''; return; }
        var file = files[0];
        var valid = file && ((file.type && file.type.indexOf('image/') === 0) || isPdfFile(file));
        if (replaceIndex >= 0) {
          if (valid) addFileToNextSlot(file, replaceIndex);
          replaceIndex = -1;
          this.value = '';
          return;
        }
        for (var i = 0; i < Math.min(files.length, 4); i++) {
          var emptyCount = 0;
          for (var j = 0; j < 4; j++) if (!slotData[j]) emptyCount++;
          if (emptyCount === 0) break;
          file = files[i];
          valid = file && ((file.type && file.type.indexOf('image/') === 0) || isPdfFile(file));
          if (valid) addFileToNextSlot(file);
        }
        this.value = '';
      });

      root.addEventListener('multi-stepper-form-reset-uploads', function() {
        for (var i = 0; i < 4; i++) {
          if (slotData[i] && slotData[i].url) URL.revokeObjectURL(slotData[i].url);
          slotData[i] = null;
        }
        renderAdditionalSlots();
      });
    }
    root.querySelectorAll('[data-next-step]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var stepEl = this.closest && this.closest('.multi-stepper-form__step');
        if (stepEl && (stepEl.classList.contains('multi-stepper-form__step--confirmation') || stepEl.querySelector('[data-confirmation-block]'))) {
          onFormSubmit();
          return;
        }
        var goto = this.getAttribute('data-goto-step');
        var stepNum = parseInt(goto, 10);
        var currentStepNum = stepEl ? (parseInt((stepEl.className.match(STEP_REGEX) || [])[1], 10) || 1) : 1;
        if (stepEl && stepEl.querySelectorAll('input[required], input[data-required], textarea[required], textarea[data-required], select[required], select[data-required]').length > 0 && typeof validateStepInputs === 'function' && !validateStepInputs(currentStepNum)) return;
        if (stepNum === 2) {
          initStep2Plus();
          filterServicesByItem(selectedItemLabel);
          filterItemDetailsByItem(selectedItemLabel);
          applyServicesStepContent(selectedItemLabel);
          updateReferenceUploadSections();
          updateNextButtonForStep(2);
          showStep(2);
        } else if (stepNum === 3) {
          initStep2Plus();
          renderSummary();
          filterItemDetailsByItem(selectedItemLabel);
          showStep(3);
          setTimeout(function() { updateNextButtonForStep(3); }, 0);
        } else if (stepNum === 4) {
          initStep2Plus();
          showStep(4);
          setTimeout(function() { updateNextButtonForStep(4); }, 0);
        } else if (!isNaN(stepNum) && stepNum > 0) {
          if (stepNum > 1) initStep2Plus();
          showStep(stepNum);
        }
      });
    });

    root.querySelectorAll('[data-prev-step]').forEach(function(btn) {
      btn.addEventListener('click', function() { showStep(this.getAttribute('data-goto-step') || '1'); });
    });

    root.querySelectorAll('[data-submit-another]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        resetForm();
        showStep(this.getAttribute('data-goto-step') || '1');
      });
    });

    function clearFieldError(inp) {
      if (!inp) return;
      var descId = inp.getAttribute('aria-describedby');
      if (descId) {
        var errEl = document.getElementById(descId.split(/\s+/)[0]);
        if (errEl) {
          errEl.textContent = '';
          errEl.classList.remove('is-visible');
        }
      }
      inp.classList.remove('input--error');
      inp.removeAttribute('aria-invalid');
    }
    function showFieldError(inp, message) {
      if (!inp) return;
      inp.classList.add('input--error');
      inp.setAttribute('aria-invalid', 'true');
      var descId = inp.getAttribute('aria-describedby');
      if (descId) {
        var errEl = document.getElementById(descId.split(/\s+/)[0]);
        if (errEl) {
          errEl.textContent = message || (inp.validationMessage || 'Please fill in this field.');
          errEl.classList.add('is-visible');
        }
      }
    }
    function validateStepInputs(stepNum) {
      var stepEl = getStepElement(stepNum);
      if (!stepEl) return true;
      stepEl.querySelectorAll('input, textarea, select').forEach(clearFieldError);
      var inputs = stepEl.querySelectorAll('input, textarea, select');
      for (var i = 0; i < inputs.length; i++) {
        var inp = inputs[i];
        if ((inp.hasAttribute('required') || inp.hasAttribute('data-required')) && inp.checkValidity && !inp.checkValidity()) {
          showFieldError(inp, inp.validationMessage || 'Please fill in this field.');
          inp.scrollIntoView && inp.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return false;
        }
      }
      return true;
    }

    function onFormSubmit() {
      var confirmationBlock = root.querySelector('[data-confirmation-block]');
      var isConfirmationVisible = confirmationBlock && !confirmationBlock.hidden && !confirmationBlock.classList.contains('is-submitted');
      if (isConfirmationVisible) {
        var confirmInp = root.querySelector('[data-confirmation-block] [data-confirmation-email-verify]');
        if (confirmInp) {
          confirmInp.setCustomValidity('');
          clearFieldError(confirmInp);
          if (!confirmInp.checkValidity()) {
            showFieldError(confirmInp, confirmInp.validationMessage || 'Please enter a valid email address.');
            confirmInp.scrollIntoView && confirmInp.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          var contactEmailInp = root.querySelector('[name="step3[contact_email]"]');
          var contactEmail = contactEmailInp ? (contactEmailInp.value || '').trim() : '';
          var confirmEmail = (confirmInp.value || '').trim();
          if (confirmEmail.toLowerCase() !== contactEmail.toLowerCase()) {
            confirmInp.setCustomValidity('Email addresses must match');
            showFieldError(confirmInp, 'Email addresses must match.');
            confirmInp.scrollIntoView && confirmInp.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
        }
      }
      var visibleStep = root.querySelector('.multi-stepper-form__step:not([hidden])');
      var stepNum = visibleStep ? (parseInt((visibleStep.className.match(STEP_REGEX) || [])[1], 10) || 3) : 3;
      if (!isConfirmationVisible && !validateStepInputs(stepNum)) return;
      var loaderEl = root.querySelector('[data-form-loader]');
      if (loaderEl) {
        loaderEl.classList.add('is-active');
        loaderEl.setAttribute('aria-hidden', 'false');
      }
      var desc = root.querySelector('textarea[name="description"]');
        formData.description = desc ? desc.value : null;
        formData.services = getSelectedServices();
        formData.step3_fields = {};
        var cur = getFormCurrency();
        formData.declared_value_currency = cur.symbol;
        formData.declared_value_currency_code = cur.code;
        root.querySelectorAll('.multi-stepper-form__step3-field').forEach(function(field) {
          if (field.style.display === 'none') return;
          var input = field.querySelector('input, textarea, select');
          if (input && input.name) formData.step3_fields[input.name] = input.value;
        });
        var allDetailsPanels = root.querySelectorAll('.multi-stepper-form__item-details[data-item-details-panel]');
        var itemKey = norm(selectedItemLabel || '');
        var visibleDetailsPanels = [];
        for (var vdp = 0; vdp < allDetailsPanels.length; vdp++) {
          var vp = allDetailsPanels[vdp];
          var vpLabel = norm((vp.getAttribute('data-item-label') || '').trim());
          if (itemKey !== '' && vpLabel === itemKey) visibleDetailsPanels.push(vp);
        }
        if (visibleDetailsPanels.length === 0) {
          for (var vdp2 = 0; vdp2 < allDetailsPanels.length; vdp2++) {
            if (!allDetailsPanels[vdp2].hasAttribute('hidden')) visibleDetailsPanels.push(allDetailsPanels[vdp2]);
          }
        }
        visibleDetailsPanels.forEach(function(visibleDetailsPanel) {
          visibleDetailsPanel.querySelectorAll('input, textarea, select').forEach(function(inp) {
            if (inp.name && inp.type !== 'file') formData.step3_fields[inp.name] = inp.type === 'checkbox' ? (inp.checked ? inp.value : '') : inp.value;
          });
        });
        var contactBlock = root.querySelector('[data-contact-info]');
        if (contactBlock) {
          contactBlock.querySelectorAll('input, textarea, select').forEach(function(inp) {
            if (inp.name && inp.type !== 'file') formData.step3_fields[inp.name] = inp.type === 'checkbox' ? (inp.checked ? inp.value : '') : inp.value;
          });
        }
        formData.image_uploads = [];
        formData.reference_images = getReferenceUploadImages();
        root.querySelectorAll('[data-image-uploads] [data-upload-input]').forEach(function(inp) {
          if (!inp.name) return;
          var file;
          if (inp._compressedBlob) {
            var blob = (inp._isPdf && inp._previewJpegBlob) ? inp._previewJpegBlob : inp._compressedBlob;
            var name = (inp._isPdf && inp._previewJpegBlob) ? (inp._compressedFileName || 'document.pdf').replace(/\.pdf$/i, '.jpg') : (inp._compressedFileName || (inp._isPdf ? 'document.pdf' : 'image.jpg'));
            file = new File([blob], name, { type: 'image/jpeg' });
          } else {
            file = inp.files && inp.files[0];
          }
          if (file) formData.image_uploads.push({ name: inp.name, file: file, fileName: file.name, type: file.type });
        });
        var additionalRow = root.querySelector('[data-additional-row]');
        if (additionalRow && additionalRow._additionalSlots) {
          var names = ['step3[image_3]', 'step3[image_4]', 'step3[image_5]', 'step3[image_6]'];
          additionalRow._additionalSlots.forEach(function(slot, i) {
            if (slot && (slot.blob || slot.previewBlob)) {
              var blob = (slot.isPdf && slot.previewBlob) ? slot.previewBlob : slot.blob;
              var fileName = (slot.isPdf && slot.previewBlob) ? (slot.fileName || 'document.pdf').replace(/\.pdf$/i, '.jpg') : (slot.fileName || (slot.isPdf ? 'document.pdf' : 'image.jpg'));
              formData.image_uploads.push({ name: names[i], file: new File([blob], fileName, { type: 'image/jpeg' }), fileName: fileName, type: 'image/jpeg' });
            }
          });
        }
        var allPromises = formData.image_uploads.map(function(item) {
          return blobToBase64(item.file).then(function(base64) {
            item.base64 = base64;
            return item;
          });
        });
        formData.reference_images.forEach(function(r) {
          var file = r.file instanceof File ? r.file : new File([r.file], r.fileName || 'image.jpg', { type: 'image/jpeg' });
          allPromises.push(blobToBase64(file).then(function(base64) {
            r.base64 = base64;
            r.fileName = r.fileName || 'image.jpg';
            return r;
          }));
        });
        Promise.all(allPromises).then(function() {
          var gasUrl = root.getAttribute('data-gas-url');
          if (gasUrl) {
            var first = (formData.step3_fields['step3[contact_first_name]'] || '').trim();
            var last = (formData.step3_fields['step3[contact_last_name]'] || '').trim();
            var name = (first + ' ' + last).trim() || (formData.step3_fields['step3[contact_email]'] || '').trim() || '—';
            var email = (formData.step3_fields['step3[contact_email]'] || '').trim() || '—';
            var images = formData.image_uploads.map(function(item) {
              var raw = item.base64 && item.base64.indexOf(',') >= 0 ? item.base64.split(',')[1] : (item.base64 || '');
              return {
                filename: item.fileName || 'image.jpg',
                mimeType: 'image/jpeg',
                data: raw
              };
            });
            var referenceImages = formData.reference_images.map(function(r) {
              var raw = r.base64 && r.base64.indexOf(',') >= 0 ? r.base64.split(',')[1] : (r.base64 || '');
              return {
                serviceTitle: r.serviceTitle,
                filename: r.fileName || 'reference.jpg',
                mimeType: 'image/jpeg',
                data: raw
              };
            });
            var vals = getStep3ValuesFromDOM();
            var addItems = vals.extraFields.filter(function(f) { return f.groupType === 'additional-services' && f.value; });
            var watchItems = vals.extraFields.filter(function(f) { return f.groupType === 'watch-problems' && f.value; });
            var promptItems = vals.extraFields.filter(function(f) { return f.groupType === 'jewelry-services-prompts' && f.value && !f.isCheckbox; });
            if (promptItems.length === 0) {
              var jewelryPromptKeys = [
                { key: 'step3[jewelry_services_sizing_text]', label: 'What size are you requesting' },
                { key: 'step3[jewelry_services_sizing_balls_text]', label: 'What balls sizing are you requesting' },
                { key: 'step3[jewelry_services_engraving_text]', label: 'What needs to be engraved' },
                { key: 'step3[jewelry_services_chain_extender_text]', label: 'How many inches are needed to be extended' },
                { key: 'step3[jewelry_services_other_text]', label: 'Please describe the service needed' }
              ];
              jewelryPromptKeys.forEach(function(p) {
                var v = (formData.step3_fields[p.key] || '').trim();
                if (v) promptItems.push({ label: p.label, value: v });
              });
            }
            var extraItems = vals.extraFields.filter(function(f) { return !f.groupType && f.value; });
            var jewelryItems = vals.extraFields.filter(function(f) { return f.groupType === 'jewelry-services' && f.value; });
            var servicesToShow = vals.services.slice();
            jewelryItems.forEach(function(f) { servicesToShow.push({ title: f.value, description: '' }); });
            root.querySelectorAll('[data-jewelry-services-checkboxes] input[type="checkbox"]:checked').forEach(function(cb) {
              var svc = (cb.value || '').trim();
              if (svc && servicesToShow.every(function(s) { return s.title !== svc; })) servicesToShow.push({ title: svc, description: '' });
            });
            var reviewDisplay = {
              item: vals.item || '—',
              services: servicesToShow.map(function(s) { return { title: s.title, description: s.description || '' }; }),
              additionalServices: addItems.length ? { heading: addItems[0].groupHeading || 'Additional Services', items: addItems } : null,
              commonWatchProblems: watchItems.length ? { heading: watchItems[0].groupHeading || 'Common Watch Problems', items: watchItems } : null,
              servicesAdditional: (promptItems.length || vals.jewelryAdditionalInfo || vals.jewelryType) ? {
                heading: 'Services additional information',
                jewelryType: vals.jewelryType || '',
                jewelryAdditionalInfo: vals.jewelryAdditionalInfo || '',
                promptItems: promptItems
              } : null,
              itemDetails: {
                extraFields: extraItems,
                declaredValue: vals.declaredValue ? ((vals.declaredValueCurrency || '$') + vals.declaredValue) : '—',
                brand: vals.brand || '—',
                tellMore: vals.tellMore || '—'
              }
            };
            var payload = {
              name: name,
              email: email,
              images: images,
              reference_images: referenceImages,
              item: formData.item,
              services: formData.services,
              step3_fields: formData.step3_fields,
              description: formData.description,
              declared_value_currency: formData.declared_value_currency,
              declared_value_currency_code: formData.declared_value_currency_code,
              review_display: reviewDisplay
            };
            var formBody = 'data=' + encodeURIComponent(JSON.stringify(payload));
            var msgEl = root.querySelector('[data-form-message]');
            fetch(gasUrl, {
              method: 'POST',
              body: formBody,
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then(function(res) { return res.text(); }).then(function(text) {
              if (loaderEl) { loaderEl.classList.remove('is-active'); loaderEl.setAttribute('aria-hidden', 'true'); }
              if (msgEl) msgEl.textContent = text && text.trim().toLowerCase() === 'success' ? '' : text;
              if (text && text.trim().toLowerCase() === 'success') {
                if (typeof resetForm === 'function') resetForm();
                var confirmationBlock = root.querySelector('[data-confirmation-block]');
                if (confirmationBlock) {
                  confirmationBlock.classList.add('is-submitted');
                }
              }
            }).catch(function(err) {
              if (loaderEl) { loaderEl.classList.remove('is-active'); loaderEl.setAttribute('aria-hidden', 'true'); }
              if (msgEl) msgEl.textContent = 'Error submitting form.';
            });
          } else if (typeof window.multiStepperFormSubmit === 'function') {
            window.multiStepperFormSubmit(formData);
            if (loaderEl) { loaderEl.classList.remove('is-active'); loaderEl.setAttribute('aria-hidden', 'true'); }
          } else {
            console.log('Form data:', formData);
            if (loaderEl) { loaderEl.classList.remove('is-active'); loaderEl.setAttribute('aria-hidden', 'true'); }
          }
        }).catch(function(err) {
          console.error('Error converting images to base64:', err);
          var loaderEl = root.querySelector('[data-form-loader]');
          if (loaderEl) { loaderEl.classList.remove('is-active'); loaderEl.setAttribute('aria-hidden', 'true'); }
          var gasUrl = root.getAttribute('data-gas-url');
          if (gasUrl) {
            var msgEl = root.querySelector('[data-form-message]');
            if (msgEl) msgEl.textContent = 'Error submitting form.';
          } else if (typeof window.multiStepperFormSubmit === 'function') {
            window.multiStepperFormSubmit(formData);
          } else {
            console.log('Form data:', formData);
          }
        });
    }
    root.querySelectorAll('.multi-stepper-form__btn--submit, [data-confirmation-submit]').forEach(function(btn) {
      btn.addEventListener('click', onFormSubmit);
    });

    showStep(1);
    updateNextButtonForStep(1);
  }

  function run() {
    var forms = document.querySelectorAll('.multi-stepper-form[id^="MultiStepperForm-"]');
    for (var i = 0; i < forms.length; i++) init(forms[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
